<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 155px !important; margin-right: auto !important;' : ''">
    <v-alert v-if="alert" class="mb-3 ml-1" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showDateStart != '' && showDateEnd != '' && isShowDate == true
      }"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicSentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          no-data-text="No topic available"
          dense
          outlined
          rounded
          @change="parameterProsesTopic"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          v-model="selectedKeywords"
          :items="topicKeywordSentiment"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          no-data-text="No keyword available"
          multiple
          dense
          outlined
          rounded
          @change="handleMultipleKeyword"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 1" :key="index" small>
              {{ item }}
            </v-chip>
            <span
              v-if="index == 1"
              class="text-grey text-caption align-self-center"
            >
              (+{{ selectedKeywords.length - 1 }} others)
            </span>
          </template>
        </v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="periodeBerita"
          item-text="name"
          item-value="value"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameterProsesPeriode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small dark width="120" color="var(--color-theme)">
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="dateStart"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="dateEnd"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="var(--color-theme)" text @click="menu = false, parameterProsesCustom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 mx-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, loadSearchDashboard()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>

      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogInputTitleImage = true"
        >
          <v-icon>mdi-content-cut</v-icon>
          Capture
        </v-btn>
      </v-col>
    </v-layout>

    <div class="mb-8 d-flex justify-end">
      <v-btn
        class="d-flex align-center justify-space-between pa-0 px-2"
        :style="{
          position: 'fixed',
          bottom: '60px',
          right: '30px',
          'z-index': (dialogLoading || dialogSearchContext) ? 1 : 9999,
          'border-radius': '9999px'
        }"
        height="50"
        width="165"
        color="white"
        elevation="4"
        @click="insightAIassistant()"
      >
        <div
          class="d-flex align-center justify-center"
          :style="{ backgroundColor: 'var(--color-theme)', borderRadius: '50%', width: '36px', height: '36px' }"
        >
          <SparklesIcon class="w-4 h-4" style="color: white;" />
        </div>

        <div style="flex: 1; text-align: center;">
          <span style="text-transform: none; color: black; font-size: 14px;">
            Insights AI
          </span>
        </div>

        <v-icon
          :style="{
            'margin-top': dialogPageInsight ? '-3px' : '1px',
            transform: dialogPageInsight ? 'rotate(90deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s ease',
            color: 'black'
          }"
          size="18"
        >
          mdi-play
        </v-icon>
      </v-btn>
    </div>

    <v-layout row wrap>
      <v-flex lg4>
        <v-card class="mb-6 rounded-lg" color="#F8F6F2" flat>
          <v-row class="pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 mb-6 rounded-lg pa-4" :style="navbarWithName ? 'width: 400px;' : ''" height="350px" flat>
                <div class="mt-2 ml-4 font-weight-medium" style="font-size: 22px;">
                  Sentiment Analysis
                </div>
                <div class="ml-4 grey--text" style="font-size: 15px;">
                  Public Sentiment Distribution
                </div>

                <div class="chart-wrapper">
                  <apexchart
                    :options="chartPie"
                    :series="seriesDonut"
                    type="donut"
                    width="350px"
                    style="cursor: pointer"
                    @dataPointSelection="filterBySentiment"
                  ></apexchart>
                </div>
              </v-card>
            </v-flex>

            <v-flex lg12 sm12 md12 xs12>
              <v-card class="mx-4 rounded-lg pa-4" :style="navbarWithName ? 'width: 400px;' : ''" height="455px" flat>
                <div class="ml-4 font-weight-medium" style="font-size: 22px;">
                  Content List
                </div>
                <div class="ml-4 grey--text" style="font-size: 15px;">
                  Filtered Content Display
                </div>

                <v-tabs v-model="selectedTab" :key="selectedTab" center-active color="#0471A5">
                  <v-tab @click="contentListSentiment('Positive')">
                    Positive
                    <v-chip small class="ma-2" color="#0471A5" text-color="white">
                      {{ beritaPositivePersen }} % / {{ beritaPositive }} Data
                    </v-chip>
                  </v-tab>
                  <v-tab class="ml-8" @click="contentListSentiment('Neutral')">
                    Neutral
                    <v-chip small class="ma-2" color="#0471A5" text-color="white">
                      {{ beritaNetralPersen }} % / {{ beritaNetral }} Data
                    </v-chip>
                  </v-tab>
                  <v-tab class="ml-8" @click="contentListSentiment('Negative')">
                    Negative
                    <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                      {{ beritaNegativePersen }} % / {{ beritaNegative }} Data
                    </v-chip>
                  </v-tab>

                  <v-tab-item style="background-color: #fff">
                    <v-card class="elevation-0 overflow-card" height="310px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaPositive" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar-berita-online" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-thin fa-globe
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar-youtube" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-brands fa-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Tik tok'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Instagram'" class="color-avatar-instagram" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>

                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item style="background-color: #fff">
                    <v-card class="elevation-0 overflow-card" height="310px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaNetral" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar-berita-online" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-thin fa-globe
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar-youtube" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-brands fa-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Tik tok'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Instagram'" class="color-avatar-instagram" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>

                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item style="background-color: #fff">
                    <v-card class="elevation-0 overflow-card" height="310px">
                      <v-row class="ma-2">
                        <v-flex v-for="(item, index) in kontenBeritaNegative" :key="item.id" lg12>
                          <v-card
                            :href="item.url"
                            target="_blank"
                            flat
                            :class="{ 'rounded-lg content-list-card': index == 0, 'mt-2 rounded-lg content-list-card': index != 0 }"
                            style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                          >
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.title }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                                      {{ item.content }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                                      <div class="d-flex align-center">
                                        <v-avatar v-if="item.source == 'berita'" class="color-avatar-berita-online" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-thin fa-globe
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Twitter'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-x-twitter
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'youtube'" class="color-avatar-youtube" size="26">
                                          <v-icon class="white--text" size="18">
                                            fa-brands fa-youtube
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Tik tok'" class="color-avatar-x-tik-tok-threads" size="26">
                                          <v-icon class="white--text" size="22">
                                            fa-brands fa-tiktok
                                          </v-icon>
                                        </v-avatar>

                                        <v-avatar v-if="item.source == 'Instagram'" class="color-avatar-instagram" size="26">
                                          <v-icon class="white--text" size="22">
                                            mdi-instagram
                                          </v-icon>
                                        </v-avatar>

                                        <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                          {{ item.url }}
                                        </span>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card>

              <div v-if="tabsSentiment == 'Positive'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pagePositive"
                  :length="pageLengthPositive"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangePositive"
                ></v-pagination>
              </div>
              <div v-if="tabsSentiment == 'Neutral'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pageNetral"
                  :length="pageLengthNetral"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangeNetral"
                ></v-pagination>
              </div>
              <div v-if="tabsSentiment == 'Negative'" class="text-center">
                <v-pagination
                  class="mt-2 my-2"
                  v-model="pageNegative"
                  :length="pageLengthNegative"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="handlePageChangeNegative"
                ></v-pagination>
              </div>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg8 sm12 md12 xs12>
        <v-card :class="navbarWithName ? 'ml-6 mb-6 rounded-lg' : 'mb-6 rounded-lg'" style="background-color: #fff;" color="#F8F6F2" flat>
          <div class="px-6 pt-6 pb-2">
            <div class="font-weight-medium" style="font-size: 22px;">
              Statistics
            </div>
            <div class="grey--text" style="font-size: 15px;">
              Keyword Significancy
            </div>
          </div>

          <v-row class="mx-2 mt-2 mb-4">
            <v-flex lg4 sm4 md4 xs4>
              <v-card class="mx-2 mb-10 rounded-lg" elevation="2" flat>
                <v-list-item class="pa-3">
                  <v-avatar class="color-avatar-total-collected-data" size="48">
                    <v-icon class="white--text">
                      fa-brands fa-ubuntu
                    </v-icon>
                  </v-avatar>
                  <v-list-item-content class="ml-3">
                    <v-list-item-subtitle class="accent-2 mb-1">
                      <h3 class="statistic-title">
                        Total Collected Data
                      </h3>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="primary--text text-h6 mb-1">
                      {{ selectedTopicTotalCollectedData }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <h2 color="deep-purple accent-2">
                        {{ totalCollectedData }}
                      </h2>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-flex>

            <v-flex lg4 sm4 md4 xs4>
              <v-card class="mx-2 mb-3 rounded-lg" elevation="2" flat>
                <v-list-item class="pa-3">
                  <v-avatar class="color-avatar-most-crawled-keyword" size="48">
                    <v-icon class="white--text">
                      fa-solid fa-font
                    </v-icon>
                  </v-avatar>
                  <v-list-item-content class="ml-3">
                    <v-list-item-subtitle class="accent-2 mb-1">
                      <h3 class="statistic-title">
                        Most Crawled Keyword
                      </h3>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="primary--text text-h6 mb-1">
                      {{ valueMostTotalKeyword.name }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <h2 color="deep-purple">
                        {{ valueMostTotalKeyword.count }}
                      </h2>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-flex>

            <v-flex lg4 sm4 md4 xs4>
              <v-card class="mx-2 mb-3 rounded-lg" elevation="2" flat>
                <v-list-item class="pa-3">
                  <v-avatar class="color-avatar-least-crawled-keyword" size="48">
                    <v-icon class="white--text">
                      fa-thin fa-clock
                    </v-icon>
                  </v-avatar>
                  <v-list-item-content class="ml-3">
                    <v-list-item-subtitle class="accent-2 mb-1">
                      <h3 class="statistic-title">
                        Least Crawled Keyword
                      </h3>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="primary--text text-h6 mb-1">
                      {{ valueLeastTotalKeyword.name }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <h2 color="deep-purple accent-2">
                        {{ valueLeastTotalKeyword.count }}
                      </h2>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>

        <v-flex lg12 sm12 md12 xs12>
          <v-card
            class="mt-6 px-4 pt-4 pb-10 rounded-lg"
            :height="cardHeight"
            flat
          >
            <div class="mt-4 ml-4 font-weight-medium" style="font-size: 22px;">
              Periodic Crawled Data
            </div>
            <div class="ml-4 grey--text" style="font-size: 15px;">
              Cross-Platform Data Volume Over Time
            </div>

            <v-carousel
              hide-delimiters
              :height="carouselHeight"
            >
              <v-carousel-item>
                <apexcharts
                  :options="sentimentAnalysis"
                  :series="seriesSentiment"
                  class="py-4"
                  type="area"
                  width="100%"
                  height="360px"
                ></apexcharts>

                <v-row
                  :class="{
                    'mb-4': listSourceCollection.length > 0
                  }"
                  justify="center"
                  align="center"
                  style="flex-wrap: wrap; max-width: 810px; margin: auto;"
                >
                  <v-flex
                    v-for="item in listSourceCollection"
                    :key="item.ID"
                    :class="[
                      'd-flex',
                      'justify-center'
                    ]"
                    :style="{
                      marginTop: '10px',
                      flex: listSourceCollection.length == 7
                        ? '0 0 calc(25% - 16px)'
                        : listSourceCollection.length == 6
                        ? '0 0 calc(25% - 16px)'
                        : listSourceCollection.length == 5
                        ? '0 0 calc(20% - 16px)'
                        : listSourceCollection.length == 4
                        ? '0 0 calc(25% - 16px)'
                        : listSourceCollection.length == 3
                        ? '0 0 calc(33.333% - 16px)'
                        : listSourceCollection.length == 2
                        ? '0 0 calc(50% - 16px)'
                        : '0 0 185px',
                      maxWidth: listSourceCollection.length == 7
                        ? 'calc(25% - 16px)'
                        : listSourceCollection.length == 6
                        ? 'calc(25% - 16px)'
                        : listSourceCollection.length == 5
                        ? 'calc(20% - 16px)'
                        : listSourceCollection.length == 4
                        ? 'calc(25% - 16px)'
                        : listSourceCollection.length == 3
                        ? 'calc(33.333% - 16px)'
                        : listSourceCollection.length == 2
                        ? 'calc(50% - 16px)'
                        : '185px',
                      minWidth: '140px',
                      margin: '10px 8px'
                    }"
                  >
                    <v-btn
                      class="mt-1"
                      :style="{
                        backgroundColor: selectedSourceId == item.ID ? '#e1f2fa' : '#fff',
                        width: '100%',
                        maxWidth: '175px',
                        minWidth: '140px'
                      }"
                      style="
                        color: #0471A5;
                        border-radius: 8px;
                        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                      color="#fff"
                      height="80"
                      x-large
                      @click="
                        if (selectedSourceId == item.ID) {
                          selectedSourceId = '';
                          selectedSource = '';
                          changeBackgroundColor = false;
                          loadChartPie();
                        } else {
                          selectedSourceId = item.ID;
                          selectedSource = item.NAME_COLLECTION;
                          changeBackgroundColor = true;
                          loadChartArea();
                        }
                      "
                    >
                      <v-card-text class="pa-2">
                        <h2 class="text--teal darken-2" align="center">
                          <v-avatar v-if="item.ICON == 'fa-thin fa-globe'" class="color-avatar-berita-online" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-x-twitter'" class="color-avatar-x-tik-tok-threads" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-youtube'" class="color-avatar-youtube" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-tiktok'" class="color-avatar-x-tik-tok-threads" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'mdi-instagram'" class="color-avatar-instagram" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'mdi-facebook'" class="color-avatar-facebook" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <v-avatar v-if="item.ICON == 'fa-brands fa-threads'" class="color-avatar-x-tik-tok-threads" size="36">
                            <v-icon class="white--text">
                              {{ item.ICON }}
                            </v-icon>
                          </v-avatar>
                          <span v-if="item.ICON == 'fa-thin fa-globe'">
                            {{ valueTotalBerita }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalBerita / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-x-twitter'">
                            {{ valueTotalTweet }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalTweet / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-youtube'">
                            {{ valueTotalYoutube }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalYoutube / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-tiktok'">
                            {{ valueTotalTikTok }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalTikTok / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'mdi-instagram'">
                            {{ valueTotalInstagram }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalInstagram / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'mdi-facebook'">
                            {{ valueTotalFacebook }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalFacebook / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                          <span v-if="item.ICON == 'fa-brands fa-threads'">
                            {{ valueTotalThreads }}
                            <span style="font-size: 16px; font-weight: 400;">
                              ({{ totalCollectedData ? Math.round((valueTotalThreads / totalCollectedData) * 100) : 0 }}%)
                            </span>
                          </span>
                        </h2>
                        <h5
                          v-if="item.ICON == 'fa-thin fa-globe'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Online News
                        </h5>
                        <h5
                          v-if="item.ICON == 'fa-brands fa-x-twitter'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Tweet
                        </h5>
                        <h5
                          v-if="item.ICON == 'fa-brands fa-youtube'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Youtube Comment
                        </h5>
                        <h5
                          v-if="item.ICON == 'fa-brands fa-tiktok'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          TikTok Comment
                        </h5>
                        <h5
                          v-if="item.ICON == 'mdi-instagram'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Instagram Comment
                        </h5>
                        <h5
                          v-if="item.ICON == 'mdi-facebook'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Facebook Comment
                        </h5>
                        <h5
                          v-if="item.ICON == 'fa-brands fa-threads'"
                          class="text--teal darken-2"
                          style="margin-top: 3px;"
                          align="center"
                        >
                          Threads Comment
                        </h5>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                </v-row>
              </v-carousel-item>

              <v-carousel-item>
                <v-row>
                  <v-col cols="12" md="9">
                    <apexcharts
                      :options="optionSpecificKeyword"
                      :series="seriesSpecificKeyword"
                      class="mt-2 py-2"
                      type="area"
                      width="100%"
                      height="360px"
                    ></apexcharts>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-card
                      class="card-add-specific-keyword mx-2 my-3"
                      style="max-height: 350px; overflow-y: auto;"
                      color="#fff"
                      outlined
                      x-large
                    >
                      <v-card-text>
                        <h2 class="primary--text darken-2 my-2" align="center">
                          <v-icon>mdi-plus</v-icon>
                        </h2>
                        <h4 class="text--teal darken-2 my-2" align="center">
                          Add Specific Keyword
                        </h4>
                        <v-select
                          :items="topicSpecificKeyword"
                          v-model="selectedAddSpecificKeyword"
                          class="elevation-0 shadow-0"
                          label="Keyword"
                          no-data-text="No keyword available"
                          dense
                          outlined
                          rounded
                          multiple
                          @change="handleAddSpecificKeyword"
                        ></v-select>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      flex-wrap: nowrap;
                      overflow: hidden;
                      width: 800px;
                    "
                  >
                    <v-icon
                      v-if="listValueSpecificKeyword.length > 3"
                      class="ml-8 mr-4"
                      @click="prevSlideSpecificKeyword"
                      :disabled="startIndexSpecificKeyword == 0"
                    >
                      mdi-arrow-left
                    </v-icon>

                    <div
                      v-for="item in visibleSpecificKeyword"
                      :key="item.name"
                      style="margin: 0 20px; width: 180px; flex-shrink: 0;"
                    >
                      <v-card class="mt-2 elevation-0" outlined>
                        <v-card-text>
                          <h2 class="primary--text darken-2 my-2" align="center">
                            {{ item.count }}
                          </h2>
                          <h4 class="text--teal darken-2 my-2" align="center">
                            {{ item.name }}
                          </h4>
                        </v-card-text>
                      </v-card>
                    </div>

                    <v-icon
                      v-if="listValueSpecificKeyword.length > 3"
                      class="mr-10 ml-4"
                      @click="nextSlideSpecificKeyword"
                      :disabled="startIndexSpecificKeyword + maxVisibleSpecificKeyword >= listValueSpecificKeyword.length"
                    >
                      mdi-arrow-right
                    </v-icon>
                  </div>
                </v-row>
              </v-carousel-item>
            </v-carousel>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-layout style="margin-top: 40px; margin-left: 2px; margin-right: -4px;" row wrap>
      <v-flex lg6>
        <v-card
          class="chart-bar-card-wrapper mr-3 mb-6 pa-4 rounded-lg"
          :style="
            $vuetify.breakpoint.mdAndDown || listSourceCollection.length == 6
              ? 'margin-top: 24px;'
              : ''
          "
          height="400"
          flat
        >
          <v-flex lg12 sm12 md12 xs12>
            <v-card class="mb-6 pa-4 rounded-lg" :style="navbarWithName ? 'width: 400px;' : ''" height="350px" flat>
              <div class="ml-4 font-weight-medium" style="font-size: 22px;">
                Online News Portal
              </div>
              <div class="ml-4 mb-1 grey--text" style="font-size: 15px;">
                Portal-Based Online Media Data
              </div>

              <apexchart
                :options="barChart"
                :series="seriesBarOnlineNews"
                type="bar"
                height="300"
              />
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex lg6>
        <v-card
          :class="[
            'chart-bar-card-wrapper',
            'ml-2',
            'mb-6',
            'pa-4',
            'rounded-lg',
            listSourceCollection.length == 6 ? 'mt-6' : ''
          ]"
          height="400"
          flat
        >
          <v-flex lg12 sm12 md12 xs12>
            <v-card class="mx-4 mb-6 pa-4 rounded-lg" :style="navbarWithName ? 'width: 400px;' : ''" height="350px" flat>
              <div class="ml-4 font-weight-medium" style="font-size: 22px;">
                Social Media Channels
              </div>
              <div class="ml-4 mb-1 grey--text" style="font-size: 15px;">
                Channel-Based Social Media Data
              </div>

              <apexchart
                :options="barChartSocialMedia"
                :series="seriesBarSocialMedia"
                type="bar"
                height="300"
              />
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>

      <v-overlay v-model="overlayDialogLoading">
        <v-dialog v-model="dialogLoading" persistent max-width="290">
          <v-card>
            <v-card-title class="text-h6 font-weight-medium align-center justify-center">
              Page loading
            </v-card-title>
            <v-card-text class="body-1 align-center justify-center">
              {{ isCapture ? 'Loading capture, please wait' : 'Loading content, please wait' }}
            </v-card-text>
            <v-card-title class="align-center justify-center pt-2 pb-4">
              <v-progress-circular
                color="var(--color-theme)"
                :size="70"
                :width="7"
                indeterminate
              ></v-progress-circular>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="var(--color-theme)"
                text
                @click="overlayDialogLoading = false, dialogLoading = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-overlay>

      <v-dialog v-model="dialogSearchContext" height="500" width="350">
        <v-card class="pa-5" color="var(--color-theme-secondary)" rounded="lg" dark>
          <v-btn class="btn-close-dialog-search-context" icon @click="dialogSearchContext = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-card-text class="text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px;">
            <h3 class="white--text mb-4">
              Keyword Search Results
            </h3>
            <p class="white--text">
              Topic: <strong>{{ selectedTopicTotalCollectedData }}</strong>
              <br>
              From: <strong>{{ searchContextStartDate }}</strong> to <strong>{{ searchContextEndDate }}</strong>
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="border-radius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="border-radius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                isClickSentiment = false,
                statusFilter = '',
                selectedSource = '',
                selectedSourceId = '',
                changeBackgroundColor = false,
                loadTopic(),
                parameterProsesPeriode(),
                filterReset()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPageInsight" attach="#floating-dialog-anchor" width="340" scrollable hide-overlay>
        <v-card style="position: fixed; bottom: 120px; right: 30px; border-radius: 12px; height: 460px; width: 60%" elevation="8">
          <v-card-title class="white--text" :style="{ backgroundColor: 'var(--color-theme)' }">
            <SparklesIcon class="w-4 h-4" style="color: white;" />
            <span class="ml-2 font-weight-bold">
              Insights AI Assistant
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="regenerateInsight">
              <v-icon
                color="white"
                :class="{ 'rotate-animation': isRotatingRegenerateInsight }"
                style="transform: rotate(90deg);"
              >
                mdi-sync
              </v-icon>
            </v-btn>
            <v-btn icon @click="dialogPageInsight = false">
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="mt-5" style="max-height: 345px; overflow-y: auto;">
            <div v-if="loadingResponseDescribeDashboard && listResponseDescribeDashboard.length == 0" class="loading-dots">
              <span>.</span><span>.</span><span>.</span>
            </div>

            <div
              v-if="
                !loadingResponseDescribeDashboard &&
                listResponseDescribeDashboard.length == 1 &&
                listResponseDescribeDashboard[0] == 'The server is busy. Please try again later.'
              "
            >
              <div class="d-flex justify-end">
                <div
                  class="response-text-describe-dashboard rounded-lg"
                  style="width: 100%"
                  v-html="formatTextDescribeDashboard(listResponseDescribeDashboard[0])"
                ></div>
              </div>
            </div>

            <div v-else v-for="(item, index) in listResponseDescribeDashboard" :key="index" class="mb-2">
              <template v-if="currentLoadingIndex == index">
                <div class="loading-dots">
                  <span>.</span><span>.</span><span>.</span>
                </div>
              </template>
              <template v-else-if="currentLoadingIndex > index">
                <div class="d-flex justify-end">
                  <div
                    class="response-text-describe-dashboard rounded-lg"
                    style="width: 100%"
                    v-html="formatTextDescribeDashboard(item)"
                  ></div>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <div id="floating-dialog-anchor"></div>

      <v-dialog v-model="dialogInputTitleImage" persistent max-width="400">
        <v-card class="pa-4" rounded="xl" elevation="10">
          <v-btn
            class="confirm-reset ma-0 pa-0"
            style="position: absolute; top: 8px; right: 8px;"
            color="#aaa"
            icon
            small
            @click="dialogInputTitleImage = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title class="justify-center text-center">
            <span v-if="inputTitleNewsletter == true" class="text-h6 font-weight-medium">
              Newsletter Title
            </span>
            <span v-if="inputImageNewsletter == true" class="text-h6 font-weight-medium">
              Newsletter Cover Image
            </span>
          </v-card-title>

          <v-card-text>
            <p v-if="inputTitleNewsletter == true" class="text-body-2 text-grey-darken-1 text-center mb-4">
              Please enter a title for your newsletter below.
            </p>
            <p v-if="inputImageNewsletter == true" class="text-body-2 text-grey-darken-1 text-center mb-4">
              Please input a image for your newsletter below.
            </p>

            <v-text-field
              v-if="inputTitleNewsletter == true"
              v-model="newsletterTitle"
              label="Enter title..."
              class="rounded-lg"
              color="var(--color-theme-secondary)"
              variant="outlined"
              hide-details="auto"
              :error="newsletterTitleError"
              :error-messages="newsletterTitleError ? 'Newsletter title is required' : ''"
              @input="clearNewsletterTitleError"
              @keyup.enter="handleNextSaveNewsletter"
            ></v-text-field>

            <v-col cols="12" v-if="inputImageNewsletter == true">
              <div v-if="!imageNewsletter">
                <div
                  :class="[
                    'drop-zone-image-newsletter',
                    draggingImageNewsletter ? 'drop-zone-image-newsletter-over' : '',
                  ]"
                  @dragenter.prevent="draggingImageNewsletter = true"
                  @dragover.prevent
                  @dragleave.prevent="draggingImageNewsletter = false"
                  @drop.prevent="handleDropImageNewsletter"
                >
                  <div
                    class="drop-zone-image-newsletter-info"
                    ref="file"
                    @drag="selectImageNewsletter"
                  >
                    <span class="fa fa-cloud-upload drop-zone-image-newsletter-title"></span>
                    <span class="drop-zone-image-newsletter-title">
                      Drop image or click to input<br />
                    </span>
                    <div class="drop-zone-image-newsletter-upload-limit-info"></div>
                  </div>
                  <input
                    type="file"
                    ref="file"
                    id="files"
                    name="files"
                    @change="selectImageNewsletter"
                  />
                </div>
              </div>
              <div v-else class="drop-zone-image-newsletter-uploaded">
                <div class="drop-zone-image-newsletter-uploaded-info">
                  <button
                    class="btn remove-image-newsletter"
                    style="background-color: var(--color-theme-secondary); color: #fff; border: none;"
                    type="button"
                    @click="removeImageNewsletter"
                  >
                    Remove Image
                  </button>

                  <span class="drop-zone-image-newsletter-title"></span> <br />

                  <v-col>
                    {{ nameImageNewsletter }}
                  </v-col>
                </div>
              </div>
            </v-col>
            <p v-if="imageNewsletterError" class="ml-3 red--text">
              Newsletter cover image is required
            </p>
          </v-card-text>

          <v-divider class="my-2"></v-divider>

          <v-card-actions class="justify-end">
            <v-btn
              color="grey-darken-1"
              text
              @click="handleCancelBackNewsletter"
            >
              <span v-if="inputTitleNewsletter">
                Cancel
              </span>
              <span v-else-if="inputImageNewsletter">
                Back
              </span>
            </v-btn>

            <v-btn
              class="white--text"
              color="var(--color-theme-secondary)"
              variant="elevated"
              rounded="lg"
              @click="handleNextSaveNewsletter"
            >
              <span v-if="inputTitleNewsletter">
                Next
              </span>
              <span v-else-if="inputImageNewsletter">
                Save
              </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogWrongExtension"
        persistent
        max-width="330px"
      >
        <v-card
          class="text-center align-center justify-center pa-6 rounded-lg"
          style="border-radius: 30px"
          width="330px"
        >
          <v-avatar class="dialog-wrong-extension mb-4 mt-2" size="62">
            <v-icon x-large class="white--text">
              mdi-close
            </v-icon>
          </v-avatar>

          <div class="text-center text-h6 align-center justify-center" style="word-break: break-word">
            Image you uploaded has the wrong extension. Allowed extension jpg, jpeg, png.
          </div>
          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              class="my-3 dialog-wrong-extension"
              width="180px"
              rounded
              dark
              @click="dialogWrongExtension = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSuccessGenerateNewsletter"
        persistent
        max-width="330px"
      >
        <v-card
          class="text-center align-center justify-center pa-6 rounded-lg"
          width="330px"
        >
          <v-avatar
            color="var(--color-theme)"
            style="border: 2px solid var(--color-theme);"
            size="80"
          >
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center" style="text-wrap: wrap">
            Newsletter successfully generated
          </h1>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="var(--color-theme)"
              style="borderRadius: 8px"
              size="large"
              height="40px"
              width="120px"
              dark
              @click="dialogSuccessGenerateNewsletter = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import VueApexCharts from 'vue-apexcharts';
import Notification from '@/components/Notification';
import { decryptionData, generateFilterDate, processTopicKeywords, encodeKeywordRequest, trackEvent } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
import { SparklesIcon } from "@vue-hero-icons/solid";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import io from 'socket.io-client';
// let ipSocket = process.env.VUE_APP_API;

export default {
  components: {
    apexcharts: VueApexCharts,
    Notification: Notification,
    SparklesIcon,
  },
  data: function() {
    return {
      base64HeaderMedan247: null,
      base64HeaderSolusi247: null,
      dialogSuccessGenerateNewsletter: false,
      dialogInputTitleImage: false,
      inputTitleNewsletter: true,
      newsletterTitle: "",
      newsletterTitleError: false,
      inputImageNewsletter: false,
      draggingImageNewsletter: false,
      imageNewsletter: "",
      imageNewsletterFormat: "",
      base64ImageNewsletter: "",
      nameImageNewsletter: "",
      imageNewsletterError: false,
      dialogWrongExtension: false,
      contentAnalysisInsights: "",
      ringkasanEksekutifInsights: "",
      trenOpiniPublikInsights: "",
      sumberInformasiUtamaInsights: "",
      pageNumberNewsletter: 1,
      isCapture: false,
      isRotatingRegenerateInsight: false,
      dialogPageInsight: false,
      loadingResponseDescribeDashboard: false,
      listResponseDescribeDashboard: [],
      currentLoadingIndex: 0,
      selectedTopicInsightsAI: "",
      topicKeywordSentimentInsightAI: [],
      // socket: io(ipSocket),
      selectedTopic: "",
      selectedTopicTotalCollectedData: "",
      selectedKeyword: "",
      selectedKeywords: ["All"],
      selectedPeriode: "This Week",
      topicSentiment: [],
      topicKeywordSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      menu: false,
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      isSearch: false,
      overlayDialogLoading: false,
      dialogLoading: false,
      dialogSearchContext: false,
      searchContextStartDate: "",
      searchContextEndDate: "",
      alert: false,
      colorAlert: "",
      message: "",
      dialogConfirmReset: false,
      isClickSentiment: false,
      statusFilter: "",
      seriesDonut: [],
      chartPie: {
        colors: ['#008FFB', '#FF4560', '#00E396'],
        chart: {
          width: 380,
          type: 'pie',
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        labels: ["Neutral", "Negative", "Positive"],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
        },
        tooltip: {
          y: {
            formatter: function(val, opts) {
              try {
                const series = opts.series || (opts.globals && opts.globals.series);
                if (series && Array.isArray(series)) {
                  const total = series.reduce((a, b) => a + b, 0);
                  const percentage = total > 0 ? ((val / total) * 100).toFixed(2) : 0;
                  return val + " (" + percentage + "%)";
                }
              } catch (e) {
                console.error("Tooltip formatter error:", e);
              }
              return val;
            }
          }
        },
      },
      totalCollectedData: "",
      valueMostTotalKeyword: "",
      valueLeastTotalKeyword: "",
      top3Keywords: "",
      selectedTab: 0,
      tabsSentiment: "Positive",
      kontenBeritaAll: [],
      kontenBeritaPositive: [],
      kontenBeritaNetral: [],
      kontenBeritaNegative: [],
      beritaPositivePersen: "",
      beritaNetralPersen: "",
      beritaNegativePersen: "",
      beritaPositive: "",
      beritaNetral: "",
      beritaNegative: "",
      pagePlay: 100,
      pagePositive: "",
      pageNetral: "",
      pageNegative: "",
      pageLengthPositive: "",
      pageLengthNetral: "",
      pageLengthNegative: "",
      changeBackgroundColor: false,
      listSourceCollection: "",
      selectedSourceId: "",
      selectedSource: "",
      rowsChartArea: "",
      valueTotalBerita: "",
      valueTotalTweet: "",
      valueTotalYoutube: "",
      valueTotalTikTok: "",
      valueTotalInstagram: "",
      valueTotalFacebook: "",
      valueTotalThreads: "",
      sentimentAnalysis: {
        chart: {
          id: 'Periodic Crawled Data',
          background: 'transparent'
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
          x: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB'],
        xaxis: {
          categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriesSentiment: [],
      optionSpecificKeyword: {
        chart: {
          id: 'Periodic Crawled Data',
          background: 'transparent'
        },
        legend: {
          showForSingleSeries: true
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val;
            },
          },
          x: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ["#6F6F6F", "#FFB000", "#814AD6", "#000", "#B87333", "#bd0ca0", "#B784A7", "#e9c46a", "#F4A261", "#b9a389"],
        xaxis: {
          categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriesSpecificKeyword: [],
      topicSpecificKeyword: [],
      selectedAddSpecificKeyword: ["All"],
      listValueSpecificKeyword: [],
      prevSelectedAddSpecificKeyword: "",
      startIndexSpecificKeyword: 0,
      maxVisibleSpecificKeyword: 3,
      seriesBarOnlineNews: [{
        data: []
      }],
      barChart: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            },
            show: true,
            rotate: -45,
            rotateAlways: true,
            hideOverlappingLabels: false,
            trim: false,
            maxHeight: 120
          },
          tickAmount: 'dataPoints'
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
      seriesBarSocialMedia: [{
        data: []
      }],
      barChartSocialMedia: {
        colors: ['#38BABC', '#16A5A7', '#079092'],
        chart: {
          height: 100,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            columnWidth: '45%',
            distributed: true,
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            }
          }
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return '<div class="custom-tooltip">' +
              '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
              '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>';
          }
        }
      },
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    },
    itemsPerRow() {
      const totalSourceCollection = this.listSourceCollection.length;
      if (totalSourceCollection >= 7) return 4;
      if (totalSourceCollection === 6) return 3;
      if (totalSourceCollection === 5) return 5;
      if (totalSourceCollection === 4) return 4;
      if (totalSourceCollection === 3) return 3;
      if (totalSourceCollection === 2) return 2;
      return totalSourceCollection;
    },
    sourceRows() {
      const totalSourceCollection = this.listSourceCollection.length;
      return Math.ceil(totalSourceCollection / this.itemsPerRow);
    },
    cardHeight() {
      const baseHeight = 520;
      const extraPerRow = 180;
      return baseHeight + (this.sourceRows > 1 ? (this.sourceRows - 1) * extraPerRow : 0);
    },
    carouselHeight() {
      const baseHeight = 600;
      const extraPerRow = 180;
      return baseHeight + (this.sourceRows > 1 ? (this.sourceRows - 1) * extraPerRow : 0);
    },
    visibleSpecificKeyword() {
      return this.listValueSpecificKeyword.slice(
        this.startIndexSpecificKeyword,
        this.startIndexSpecificKeyword + this.maxVisibleSpecificKeyword
      );
    },
  },
  async created() {
    await this.loadAssetsTheme();
  },
  mounted() {
    if (window.umami) {
      window.umami.identify(localStorage.getItem("username"));
    }

    this.loadTopic();
    // this.getRealTimeData();
  },
  methods: {
    async loadAssetsTheme() {
      try {
        const appTitle = window.APP_CONFIG?.VUE_APP_TITLE || process.env.VUE_APP_TITLE;
        const assetsModule = appTitle == "Websitemedan"
          ? await import('@/constants/asset-logo-MedAn.js')
          : await import('@/constants/asset-logo-Garuda.js');

        this.base64HeaderMedan247 = assetsModule.BASE64_HEADER_MEDAN247;
        this.base64HeaderSolusi247 = assetsModule.BASE64_HEADER_SOLUSI247;
      } catch (error) {
        console.error('Failed to load environment assets:', error);
      }
    },
    handleDropImageNewsletter(event) {
      this.draggingImageNewsletter = false;
      this.selectImageNewsletter(event);
    },
    selectImageNewsletter(event) {
      const files = event.dataTransfer
        ? event.dataTransfer.files
        : event.target.files;

      if (!files || !files.length) return;

      const file = files[0];
      const fileName = file.name.toLowerCase();
      const validExtensions = ['jpg', 'jpeg', 'png'];
      const fileExtension = fileName.split('.').pop();

      if (!validExtensions.includes(fileExtension)) {
        this.dialogWrongExtension = true;
        this.removeImageNewsletter();
        if (this.$refs.file) {
          this.$refs.file.value = null;
        }
        return;
      }

      this.imageNewsletterFormat = (fileExtension == 'png') ? 'PNG' : 'JPEG';

      const reader = new FileReader();

      reader.onload = (e) => {
        const result = e.target.result;
        this.imageNewsletter = result;
        this.base64ImageNewsletter = result.split(',')[1];
        this.nameImageNewsletter = file.name;
      };

      reader.onerror = (error) => {
        console.error('Error reading image:', error);
        this.imageNewsletter = "";
        this.imageNewsletterFormat = "";
        this.base64ImageNewsletter = "";
        this.nameImageNewsletter = "";
      };

      reader.readAsDataURL(file);
      this.imageNewsletterError = false;
    },
    removeImageNewsletter() {
      this.draggingImageNewsletter = false;
      this.imageNewsletter = "";
      this.imageNewsletterFormat = "";
      this.base64ImageNewsletter = "";
      this.nameImageNewsletter = "";
    },
    handleCancelBackNewsletter() {
      if (this.inputTitleNewsletter) {
        this.dialogInputTitleImage = false;
      } else if (this.inputImageNewsletter) {
        this.inputTitleNewsletter = true;
        this.inputImageNewsletter = false;
      }
    },
    handleNextSaveNewsletter() {
      trackEvent('dashboard-capture-all', {title: this.newsletterTitle, topic: this.selectedTopicName});

      if (this.inputTitleNewsletter) {
        if (!this.newsletterTitle || this.newsletterTitle.trim() == "") {
          this.newsletterTitleError = true;
          return;
        }
        this.newsletterTitleError = false;
        this.inputTitleNewsletter = false;
        this.inputImageNewsletter = true;
      } else if (this.inputImageNewsletter) {
        if (!this.base64ImageNewsletter || this.base64ImageNewsletter.trim() == "") {
          this.imageNewsletterError = true;
          return;
        }

        this.imageNewsletterError = false;
        this.dialogInputTitleImage = false;
        this.captureAll();
      }
    },
    clearNewsletterTitleError() {
      if (this.newsletterTitleError) {
        this.newsletterTitleError = false;
      }
    },
    async captureAll() {
      this.isCapture = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      await Promise.all([
        this.insightsAICaptureAll(),
        this.insightsAIContentAnalysis()
      ]);

      const avatarScreenshots = await this.captureAvatarIcons();

      const docDashboard = new jsPDF("p", "mm", "a4");

      this.pageNumberNewsletter = 1;

      const applyPageStyle = (doc, isFirstPage = false) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const sidebarWidth = 8;
        const splitX = pageWidth / 2;

        doc.setFillColor('#FFFFFF');
        doc.rect(0, 0, pageWidth, pageHeight, 'F');
        doc.setFillColor('#165476');
        doc.rect(0, 0, sidebarWidth, pageHeight, 'F');
        if (isFirstPage) {
          this.createFirstPageHeader(doc, pageWidth, true);
        }

        let contentStartY = 52;
        const contentHeight = pageHeight - contentStartY - 15;

        const leftColumnWidth = (pageWidth / 2) - sidebarWidth;
        const leftTopHeight = contentHeight / 2;
        const leftBottomHeight = contentHeight / 2;

        doc.setFillColor('#FFFFFF');
        doc.rect(sidebarWidth, contentStartY, leftColumnWidth, leftTopHeight, 'F');
        doc.setFillColor('#FFFFFF');
        doc.rect(sidebarWidth, contentStartY + leftTopHeight, leftColumnWidth, leftBottomHeight, 'F');

        doc.setFillColor('#FFFFFF');
        doc.rect(splitX, contentStartY, splitX, contentHeight, 'F');

        const footerHeight = 15;
        const footerY = pageHeight - footerHeight;

        doc.setFillColor('#FFFFFF');
        doc.rect(sidebarWidth, footerY, pageWidth * 0.6 - sidebarWidth, footerHeight, 'F');

        doc.setFillColor('#E0E0E0');
        doc.rect(pageWidth * 0.6, footerY, pageWidth * 0.4, footerHeight, 'F');

        const logoWidth = 35;
        const logoHeight = 10;

        const logoX = pageWidth - logoWidth - 6;
        const logoY = pageHeight - footerHeight + (footerHeight - logoHeight) / 2 - 2;

        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.setTextColor("#000000");

        const poweredText = "Powered by:";
        const textWidth = doc.getTextWidth(poweredText);
        const textX = logoX - textWidth - 2;
        const textY = logoY + logoHeight - 5;

        doc.text(poweredText, textX, textY);

        if (typeof this.base64HeaderMedan247 !== "undefined" && this.base64HeaderMedan247.length > 0) {
          doc.addImage(this.base64HeaderMedan247, "PNG", logoX, logoY, logoWidth, logoHeight);
        }

        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.setTextColor("#808080");
        const pageNumberX = 15;
        const pageNumberY = pageHeight - 8;
        doc.text(`HALAMAN ${this.pageNumberNewsletter}`, pageNumberX, pageNumberY);

        this.pageNumberNewsletter++;

        if (isFirstPage) {
          const newsletterBodyBase64 = this.base64ImageNewsletter;
          const bodyImageWidth = pageWidth * 0.7;
          const bodyImageHeight = 75;
          const marginLeft = 22;
          const bodyImageX = marginLeft;
          const bodyImageY = contentStartY;

          doc.addImage(
            newsletterBodyBase64,
            this.imageNewsletterFormat,
            bodyImageX,
            bodyImageY,
            bodyImageWidth,
            bodyImageHeight
          );

          const lineX = bodyImageX + bodyImageWidth;
          const lineStartY = bodyImageY;
          const lineEndY = bodyImageY + bodyImageHeight;
          const lineWidth = 17;

          const blueBoxX = lineX;
          const blueBoxWidth = pageWidth - blueBoxX;
          const blueBoxHeight = bodyImageHeight / 5;
          const blueBoxY = lineEndY - blueBoxHeight;

          doc.setFillColor('#064B6F');
          doc.rect(blueBoxX, blueBoxY, blueBoxWidth, blueBoxHeight, 'F');

          doc.setFillColor('#25A853');
          doc.rect(lineX, lineStartY, lineWidth, bodyImageHeight, 'F');

          contentStartY = bodyImageY + bodyImageHeight + 9;

          const splitHeight = 9;
          const leftWidthSplit = pageWidth * 0.6;
          const rightWidthSplit = pageWidth * 0.4;

          doc.setFillColor('#FFFFFF');
          doc.rect(sidebarWidth, contentStartY - splitHeight, leftWidthSplit - sidebarWidth, splitHeight, 'F');

          doc.setFillColor('#064B6F');
          doc.rect(leftWidthSplit, contentStartY - splitHeight, rightWidthSplit, splitHeight, 'F');

          const contentHeight = pageHeight - contentStartY - 15;
          const sidebarWidthBody = 8;

          const leftWidth = pageWidth * 0.6;
          const rightWidth = pageWidth * 0.4;

          const rightTopHeight = contentHeight * 0.40;
          const rightBottomHeight = contentHeight * 0.60;

          doc.setFillColor('#FFFFFF');
          doc.rect(sidebarWidthBody, contentStartY, leftWidth - sidebarWidthBody, contentHeight, 'F');

          doc.setFillColor('#064B6F');
          doc.rect(leftWidth, contentStartY, rightWidth, rightTopHeight, 'F');

          doc.setFillColor('#E0E0E0');
          doc.rect(leftWidth, contentStartY + rightTopHeight, rightWidth, rightBottomHeight, 'F');

          const textX = bodyImageX + 5;
          const textY = bodyImageY + bodyImageHeight - 8;

          const textMaxWidth = bodyImageWidth * 0.7;
          doc.setFontSize(23);
          doc.setFont(undefined, 'bold');

          const splitText = doc.splitTextToSize(this.newsletterTitle, textMaxWidth);
          const padding = 5;
          const lineHeight = 8;
          let backgroundHeight = (splitText.length * lineHeight) + (padding * 2) + 14;
          let backgroundWidth = textMaxWidth + (padding * 2) + 10;

          const shiftLeft = 7;
          const backgroundX = textX - padding - shiftLeft;
          const offsetY = -2.4;

          const titleVerticalLift = 3.5;

          const backgroundHeightMultiplier = Math.max(0.06, 0.18 - (splitText.length * 0.03));

          const backgroundY =
            textY -
            (splitText.length * lineHeight) -
            padding -
            (backgroundHeight * backgroundHeightMultiplier) +
            offsetY -
            titleVerticalLift;

          doc.setFillColor('#5F5F5F');
          doc.rect(backgroundX, backgroundY, backgroundWidth, backgroundHeight, 'F');

          const titleLift = 12.5 + titleVerticalLift;
          const titleShiftLeft = 5;
          doc.setTextColor('#FFFFFF');
          const textOffsetY = 4.4;
          const textYOffset = 1;

          for (let i = 0; i < splitText.length; i++) {
            const lineY =
              textY -
              (splitText.length - 1 - i) * lineHeight +
              textOffsetY +
              textYOffset -
              titleLift;
            doc.text(splitText[i], textX - titleShiftLeft, lineY);
          }

          const topicName = this.selectedTopicTotalCollectedData;
          const totalData = this.totalCollectedData;
          const formattedTotal = totalData.toLocaleString('id-ID');

          const subtitleLines = [
            `Analisis singkat dari ${formattedTotal} percakapan digital`,
            `seputar ${topicName}.`,
          ];

          doc.setFontSize(13);
          doc.setFont(undefined, 'normal');

          const subtitleLineHeight = 4.6;
          let subtitleY = textY + 12.5 - titleLift;

          for (let i = 0; i < subtitleLines.length; i++) {
            doc.text(subtitleLines[i], textX - titleShiftLeft, subtitleY);
            subtitleY += subtitleLineHeight;
          }
        }

        return contentStartY;
      };

      const addLeftColumnContent = async (doc, yOffsetStart) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const sidebarWidthBody = 6;

        const wideColumnWidth = (pageWidth / 2) - sidebarWidthBody;
        const leftColumnWidth = (pageWidth / 2) - sidebarWidthBody - 10;

        const executiveSummaryHeight = 70.5;
        const publicOpinionTrendsHeight = 70.5;

        let executiveSummaryY = yOffsetStart;
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.setTextColor('#165476');
        doc.text("Ringkasan Eksekutif", sidebarWidthBody + 10, executiveSummaryY - 2);

        const titleWidth1 = doc.getTextWidth("Ringkasan Eksekutif");
        doc.setDrawColor('#25A853');
        doc.setLineWidth(1);
        doc.line(sidebarWidthBody + 10, executiveSummaryY + 1, sidebarWidthBody + 10 + titleWidth1 + 2, executiveSummaryY + 1);

        executiveSummaryY += 8;

        let lastYAfterSentiment = executiveSummaryY;

        if (this.ringkasanEksekutifInsights) {
          const availableHeight = executiveSummaryHeight - 12;

          const calculateOptimalFontSizeForList = (htmlContent, availableHeight, columnWidth) => {
            let fontSize = 20;
            let optimalSize = 11;

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlContent;
            const listItems = tempDiv.querySelectorAll('li');

            while (fontSize >= 11) {
              doc.setFontSize(fontSize);
              let totalHeight = 0;
              const lineHeight = fontSize * 0.35 + 1.8;
              const bulletWidth = doc.getTextWidth('• ');

              for (let item of listItems) {
                const text = item.textContent || '';
                const availableTextWidth = columnWidth - bulletWidth - 2;
                const splitText = doc.splitTextToSize(text, availableTextWidth);
                totalHeight += splitText.length * lineHeight + 1.2;
              }

              totalHeight += 1;

              if (totalHeight <= availableHeight) {
                optimalSize = fontSize;
                break;
              }
              fontSize -= 0.5;
            }

            tempDiv.remove();
            return optimalSize;
          };

          const bestFontSize = calculateOptimalFontSizeForList(
            this.formatTextReportDashboard(this.ringkasanEksekutifInsights),
            availableHeight,
            wideColumnWidth
          );

          lastYAfterSentiment = await this.renderHtmlToPdf(
            doc,
            this.formatTextReportDashboard(this.ringkasanEksekutifInsights),
            executiveSummaryY,
            wideColumnWidth,
            sidebarWidthBody + 10,
            bestFontSize
          );

          console.log("Final Y position after Ringkasan Eksekutif:", lastYAfterSentiment);
        }

        const leftBottomYStart = yOffsetStart + executiveSummaryHeight;

        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);
        doc.line(
          sidebarWidthBody + 10,
          leftBottomYStart,
          pageWidth / 2,
          leftBottomYStart
        );

        const trendsTitleY = leftBottomYStart + 8;
        doc.setFontSize(18);
        doc.setFont(undefined, 'bold');
        doc.setTextColor('#165476');
        doc.text("Tren Opini Publik", sidebarWidthBody + 10, trendsTitleY);

        let insightTextY = trendsTitleY + 9;

        if (this.trenOpiniPublikInsights) {
          const firstNewlineIndex = this.trenOpiniPublikInsights.indexOf('\n');
          const displayText = firstNewlineIndex != -1
            ? this.trenOpiniPublikInsights.substring(0, firstNewlineIndex)
            : this.trenOpiniPublikInsights;

          const formattedText = this.formatTextReportDashboard(displayText);

          const newY = await this.renderHtmlToPdf(
            doc,
            formattedText,
            insightTextY,
            wideColumnWidth,
            sidebarWidthBody + 10,
            11
          );

          insightTextY = newY;
        }

        let sentimentBoxY;
        if (this.trenOpiniPublikInsights) {
          const firstLine = this.trenOpiniPublikInsights.trim().split('\n')[0];
          const startsWithBullet = firstLine.startsWith('•') || firstLine.startsWith('-');

          if (startsWithBullet) {
            sentimentBoxY = insightTextY - 4.5;
          } else {
            sentimentBoxY = insightTextY - 2.5;
          }
        } else {
          sentimentBoxY = insightTextY - 2.5;
        }

        const sentiments = this.extractSentimentsFromInsights(this.trenOpiniPublikInsights);
        const sortedSentiments = [...sentiments].sort((a, b) => b.percent - a.percent);
        const fullWidth = leftColumnWidth - 10;
        const sorted = [...sortedSentiments].sort((a, b) => a.percent - b.percent);

        if (sorted.length == 3) {
          sorted[0].widthFactor = 0.5;
          sorted[1].widthFactor = 0.75;
          sorted[2].widthFactor = 1;
        }

        const availableSentimentHeight = publicOpinionTrendsHeight - (trendsTitleY - leftBottomYStart) - 10;
        const sentimentItemHeight = Math.min(22, availableSentimentHeight / sortedSentiments.length);

        sortedSentiments.forEach((s) => {
          const matchingItem = sorted.find(item => item.percent == s.percent);
          const widthFactor = matchingItem ? matchingItem.widthFactor : (s.percent / 100);

          const barWidth = widthFactor * fullWidth;

          doc.setFillColor(s.color);
          doc.rect(sidebarWidthBody + 10, sentimentBoxY, barWidth, 15, "F");

          doc.setTextColor("#FFFFFF");
          doc.setFontSize(11);
          doc.setFont(undefined, "normal");

          doc.text(s.label, sidebarWidthBody + 12, sentimentBoxY + 2 + 4);

          doc.setFontSize(12);
          doc.setFont(undefined, "bold");

          doc.text(
            `${s.value.toLocaleString()} Entri (${s.percent}%)`,
            sidebarWidthBody + 12,
            sentimentBoxY + 15 - 3
          );

          sentimentBoxY += sentimentItemHeight;
        });

        const titleWidth2 = doc.getTextWidth("Tren Opini Publik");
        doc.setDrawColor('#25A853');
        doc.setLineWidth(1);
        doc.line(sidebarWidthBody + 10, trendsTitleY + 3, sidebarWidthBody + 10 + titleWidth2 + 29, trendsTitleY + 3);
      };

      const addRightColumnContent = async (doc, yOffsetStart) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const leftWidth = pageWidth * 0.6;
        const rightWidth = pageWidth * 0.4;

        const contentHeight = pageHeight - yOffsetStart - 15;
        const topSectionHeight = contentHeight * 0.40;

        const rightColumnX = leftWidth + 5;
        const rightColumnWidth = rightWidth - 10;
        const rightMargin = 5;

        const adjustment = -0.5;
        let topSectionY = yOffsetStart + adjustment;

        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.setTextColor('#FFFFFF');
        doc.text("Kata Kunci Terpopuler", rightColumnX, topSectionY - 2);

        const titleWidth = doc.getTextWidth("Kata Kunci Terpopuler");
        doc.setDrawColor('#25A853');
        doc.setLineWidth(1);
        doc.line(rightColumnX, topSectionY + 1, rightColumnX + titleWidth + 2, topSectionY + 1);

        topSectionY += 13;

        const keywords = this.top3Keywords.map((item, index) => ({
          rank: index + 1,
          keyword: item.name,
          count: `${item.count} entri`
        }));

        const keywordOffsetX = 4;

        keywords.forEach((item, index) => {
          doc.setFontSize(14);
          doc.setFont(undefined, 'bold');
          doc.setTextColor('#FFFFFF');

          const circleX = rightColumnX + keywordOffsetX;
          const circleY = topSectionY - 3;
          const circleRadius = 4;

          doc.setFillColor('#FFFFFF');
          doc.circle(circleX, circleY, circleRadius, 'F');

          doc.setTextColor('#064B6F');
          doc.setFontSize(14);
          doc.text(`${item.rank}`, circleX - 1.4, circleY + 1.5);

          const textStartX = circleX + 7;
          const maxTextWidth = pageWidth - textStartX - rightMargin;

          const fullText = `${item.keyword}: ${item.count}`;

          doc.setFontSize(14);
          doc.setFont(undefined, 'bold');
          const keywordWidth = doc.getTextWidth(`${item.keyword}:`);

          doc.setFont(undefined, 'normal');
          const countWidth = doc.getTextWidth(` ${item.count}`);

          const totalWidth = keywordWidth + countWidth;

          const verticalSpacing = 14;

          if (totalWidth <= maxTextWidth) {
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#FFFFFF');
            doc.text(`${item.keyword}:`, textStartX, topSectionY - 1.2);

            doc.setFont(undefined, 'normal');
            doc.text(` ${item.count}`, textStartX + keywordWidth, topSectionY - 1.2);

            topSectionY += verticalSpacing;
          } else {
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#FFFFFF');

            const splitText = doc.splitTextToSize(fullText, maxTextWidth);
            const splitOffsetY = -2;

            splitText.forEach((line, lineIndex) => {
              if (lineIndex == 0) {
                const colonIndex = line.indexOf(':');
                if (colonIndex != -1) {
                  const keywordPart = line.substring(0, colonIndex + 1);
                  let countPart = line.substring(colonIndex + 1);
                  countPart = " " + countPart.trim();

                  doc.setFont(undefined, 'bold');
                  doc.text(keywordPart, textStartX, topSectionY - 1.2 + splitOffsetY);

                  doc.setFont(undefined, 'normal');
                  doc.text(
                    countPart,
                    textStartX + doc.getTextWidth(keywordPart) + 4,
                    topSectionY - 1.2 + splitOffsetY
                  );
                } else {
                  doc.setFont(undefined, 'bold');
                  doc.text(line, textStartX, topSectionY - 1.2 + splitOffsetY);
                }
              } else {
                doc.setFont(undefined, 'normal');
                doc.text(line, textStartX, topSectionY - 1.2 + splitOffsetY);
              }

              topSectionY += 5;
            });

            topSectionY += (verticalSpacing - 5 * splitText.length);
          }

          if (index < keywords.length - 1) {
            doc.setDrawColor('#FFFFFF');
            doc.setLineWidth(0.3);
            const lineY = topSectionY - 10;
            const lineStartX = circleX - 3;
            const lineEndX = circleX + rightColumnWidth - keywordOffsetX - 8;
            doc.line(lineStartX, lineY, lineEndX, lineY);
          }
        });

        let bottomSectionY = yOffsetStart + topSectionHeight + 5;

        const leftShiftAmount = 0.5;
        const adjustedRightColumnX = rightColumnX - leftShiftAmount;

        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        doc.setTextColor('#064B6F');
        doc.text("Sumber Informasi Utama", adjustedRightColumnX, bottomSectionY);

        const sourceTitleWidth = doc.getTextWidth("Sumber Informasi Utama");
        doc.setDrawColor('#25A853');
        doc.setLineWidth(1);
        doc.line(adjustedRightColumnX, bottomSectionY + 3, adjustedRightColumnX + sourceTitleWidth + 2, bottomSectionY + 3);

        bottomSectionY += 15;

        const sources = this.parseSumberInformasiUtama(this.sumberInformasiUtamaInsights);

        sources.forEach((item, index) => {
          if (index > 0) {
            bottomSectionY += 3;
          }

          doc.setFontSize(14);
          doc.setFont(undefined, 'bold');
          doc.setTextColor('#064B6F');

          const keywordOffsetX = 4;
          const circleX = adjustedRightColumnX + keywordOffsetX;
          const circleY = bottomSectionY - 3;
          const circleRadius = 4;

          doc.setFillColor('#064B6F');
          doc.circle(circleX, circleY, circleRadius, 'F');

          doc.setTextColor('#FFFFFF');
          doc.setFontSize(14);
          doc.text(`${item.rank}`, circleX - 1.4, circleY + 1.5);

          const textStartX = circleX + 7;
          const isCurrentCountZero = item.rawCount == 0;

          let iconSize;
          let iconYAdjustment;
          let countYAdjustment;

          if (isCurrentCountZero) {
            iconSize = 14;
            iconYAdjustment = -8;
            countYAdjustment = iconSize + 2;
          } else {
            iconSize = 19.5;
            iconYAdjustment = -8;
            countYAdjustment = iconSize - 4;
          }

          if (item.iconType && avatarScreenshots[item.iconType]) {
            const iconX = textStartX + 1;
            const iconY = bottomSectionY + iconYAdjustment;

            try {
              doc.addImage(avatarScreenshots[item.iconType], 'PNG', iconX, iconY, iconSize, iconSize);
            } catch (error) {
              console.error('Error adding icon image:', error);
            }

            const maxIconSize = 19.5;
            const nameX = iconX + maxIconSize + 3 - 9;

            doc.setFont(undefined, 'bold');
            doc.setTextColor('#064B6F');
            doc.text(item.name, nameX, bottomSectionY - 1.2);

            if (item.count) {
              const countText = `: ${item.count}`;
              const countFontSize = 11;
              doc.setFontSize(countFontSize);
              doc.setTextColor('#064B6F');

              const countX = iconX;
              const countY = iconY + countYAdjustment;

              doc.text(countText, countX, countY);
            }
          } else {
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#064B6F');
            doc.text(item.name, textStartX, bottomSectionY - 1.2);

            if (item.count) {
              doc.setFont(undefined, 'bold');
              doc.setFontSize(12);
              doc.setTextColor('#064B6F');
              doc.text(item.count, textStartX, bottomSectionY + 6);
            }
          }

          bottomSectionY += isCurrentCountZero ? 16 : 20;

          if (index < sources.length - 1) {
            doc.setDrawColor('#0E78AC');
            doc.setLineWidth(0.3);
            const lineY = bottomSectionY - 8;
            const lineStartX = circleX - 3;
            const lineEndX = circleX + rightColumnWidth - keywordOffsetX - 8;
            doc.line(lineStartX, lineY, lineEndX, lineY);
          }
        });
      };

      try {
        this.pageNumberNewsletter = 1;

        let yOffsetStart = applyPageStyle(docDashboard, true) + 5;
        const pageHeight = docDashboard.internal.pageSize.getHeight();

        await addLeftColumnContent(docDashboard, yOffsetStart, pageHeight);
        await addRightColumnContent(docDashboard, yOffsetStart);

        const pdfBytesDashboard = docDashboard.output("arraybuffer");

        const docContentAnalysis = new jsPDF("p", "mm", "a4");

        this.pageNumberNewsletter = 4;

        const addContentAnalysisSection = async (doc) => {
          const pageHeight = doc.internal.pageSize.getHeight();
          const pageWidth = doc.internal.pageSize.getWidth();

          this.createStandardPageHeader(doc, pageWidth);

          const sidebarWidth = 8;
          const footerHeight = 15;
          const footerY = pageHeight - footerHeight;

          doc.setFillColor('#FFFFFF');
          doc.rect(sidebarWidth, footerY, pageWidth - sidebarWidth * 2, footerHeight, 'F');

          doc.setFontSize(11);
          doc.setFont(undefined, "normal");
          doc.setTextColor("#808080");
          doc.text(`HALAMAN ${this.pageNumberNewsletter}`, 15, pageHeight - 8);

          this.pageNumberNewsletter++;

          const startY = 30;
          const marginX = 15;
          const columnWidth = pageWidth - 2 * marginX;

          const formattedContent = this.formatTextReportDashboard(this.contentAnalysisInsights);

          if (formattedContent && formattedContent.trim() != "") {
            const renderedY = await this.renderHtmlToPdf(
              doc,
              formattedContent,
              startY,
              columnWidth,
              marginX,
              12
            );

            return renderedY + 10;
          }

          return startY + 10;
        };

        await addContentAnalysisSection(docContentAnalysis);

        const pdfBytesContentAnalysis = docContentAnalysis.output("arraybuffer");

        const now = new Date();
        const formattedDate = now.toLocaleString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const formDataDashboard = new FormData();
        formDataDashboard.append('file', new Blob([pdfBytesDashboard], { type: 'application/pdf' }), `${this.newsletterTitle}.pdf`);
        formDataDashboard.append('title', this.newsletterTitle);
        formDataDashboard.append('nameFile', `${this.newsletterTitle}.pdf`);
        formDataDashboard.append('type', 'newsletter dashboard');
        formDataDashboard.append('date', formattedDate);
        formDataDashboard.append('topic', this.selectedTopic);
        formDataDashboard.append('periode', this.selectedPeriode);

        let responseNewsletterDashboard = null;
        try {
          responseNewsletterDashboard = await axios.post(
            "insights/upload",
            formDataDashboard,
            {
              headers: {
                "auth-token": authToken,
              },
            }
          );
          trackEvent('dashboard-upload-insight-success', {title: this.newsletterTitle, topic: this.selectedTopicName});
        } catch (err) {
          trackEvent('dashboard-upload-insight-failed', {title: this.newsletterTitle, topic: this.selectedTopicName});
          console.error("Gagal simpan newsletter dashboard:", err);
        }

        await new Promise(resolve => setTimeout(resolve, 5000));

        let responseNewsletterContent = null;
        let isUploadContentSuccess = false;

        while (!isUploadContentSuccess) {
          const formDataContent = new FormData();
          formDataContent.append('file', new Blob([pdfBytesContentAnalysis], { type: 'application/pdf' }), `${this.newsletterTitle}.pdf`);
          formDataContent.append('title', this.newsletterTitle);
          formDataContent.append('nameFile', `${this.newsletterTitle}.pdf`);
          formDataContent.append('type', 'newsletter content analysis');
          formDataContent.append('date', formattedDate);
          formDataContent.append('topic', this.selectedTopic);
          formDataContent.append('periode', this.selectedPeriode);

          try {
            responseNewsletterContent = await axios.post(
              "insights/upload",
              formDataContent,
              {
                headers: {
                  "auth-token": authToken,
                },
              }
            );

            if (responseNewsletterContent.status == 200) {
              isUploadContentSuccess = true;
            }
          } catch (err) {
            console.error("Gagal simpan newsletter content analysis:", err);
            await new Promise(resolve => setTimeout(resolve, 5000));
          }
        }

        this.dialogInputTitleImage = false;
        if (responseNewsletterDashboard.status == 200 && responseNewsletterContent.status == 200) {
          this.dialogSuccessGenerateNewsletter = true;
        }
        this.inputTitleNewsletter = true;
        this.inputImageNewsletter = false;
        this.newsletterTitle = "";
        this.removeImageNewsletter();
      } catch (error) {
        console.error('Error generating PDF:', error);
      } finally {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.isCapture = false;
      }
    },
    async captureAvatarIcons() {
      const avatarScreenshots = {};

      const iconMapping = {
        'fa-thin fa-globe': 'beritaOnline',
        'fa-brands fa-x-twitter': 'twitter',
        'fa-brands fa-youtube': 'youtube',
        'fa-brands fa-tiktok': 'tiktok',
        'mdi-instagram': 'instagram'
      };

      const avatars = document.querySelectorAll('v-avatar, .v-avatar');

      for (const avatar of avatars) {
        try {
          const icon = avatar.querySelector('i, .v-icon');
          if (!icon) continue;

          let iconType = null;
          for (const [iconClass, key] of Object.entries(iconMapping)) {
            if (
              icon.className.includes(iconClass.replace('fa-', '')) ||
              icon.className.includes(iconClass)
            ) {
              iconType = key;
              break;
            }
          }

          if (!iconType || avatarScreenshots[iconType]) continue;

          const canvas = await html2canvas(avatar, {
            backgroundColor: null,
            logging: false,
            scale: 3,
            width: 48,
            height: 48
          });

          avatarScreenshots[iconType] = canvas.toDataURL('image/png');
        } catch (error) {
          console.error('Error capturing avatar:', error);
        }
      }

      return avatarScreenshots;
    },
    extractSentimentsFromInsights(insightsText) {
      if (!insightsText) return [];

      const sentiments = [];
      const colorMap = {
        'Negatif': '#A24717',
        'Positif': '#228878',
        'Netral': '#0E78AC'
      };

      const regex = /[\s-]*\**Sentiment (Negatif|Positif|Netral)\**[^0-9]+([0-9.,]+)[^0-9]+([0-9,.]+)%/g;
      let match;

      while ((match = regex.exec(insightsText)) !== null) {
        const sentimentType = match[1];

        let valueString = match[2];
        valueString = valueString.replace(/[,.]/g, '');
        const value = parseInt(valueString);

        let percentString = match[3];

        percentString = percentString.replace(',', '.');

        const percent = parseFloat(percentString);

        sentiments.push({
          label: `Sentimen ${sentimentType}`,
          value: value,
          percent: percent,
          color: colorMap[sentimentType]
        });
      }

      if (sentiments.length == 0) {
        const fallbackRegex = /[\s-]*\**Sentiment (Negatif|Positif|Netral)\**[^0-9]+([0-9.,]+)[^0-9(]*\(([0-9,.]+)%\)/g;

        let fallbackMatch;
        while ((fallbackMatch = fallbackRegex.exec(insightsText)) !== null) {
          const sentimentType = fallbackMatch[1];

          let valueString = fallbackMatch[2];
          valueString = valueString.replace(/[,.]/g, '');
          const value = parseInt(valueString);

          let percentString = fallbackMatch[3];
          percentString = percentString.replace(',', '.');
          const percent = parseFloat(percentString);

          sentiments.push({
            label: `Sentimen ${sentimentType}`,
            value: value,
            percent: percent,
            color: colorMap[sentimentType]
          });
        }

        if (sentiments.length == 0) {
          return [
            { label: "Sentimen Negatif", value: 0, percent: 0, color: "#A24717" },
            { label: "Sentimen Positif", value: 0, percent: 0, color: "#228878" },
            { label: "Sentimen Netral", value: 0, percent: 0, color: "#0E78AC" }
          ];
        }
      }

      return sentiments;
    },
    parseSumberInformasiUtama(insightsText) {
      if (!insightsText) return [];

      const sourceMapping = {
        'twitter': { iconType: 'twitter', name: 'Twitter' },
        'news': { iconType: 'beritaOnline', name: 'Berita Online' },
        'berita online': { iconType: 'beritaOnline', name: 'Berita Online' },
        'youtube': { iconType: 'youtube', name: 'YouTube' },
        'tik tok': { iconType: 'tiktok', name: 'TikTok' },
        'tiktok': { iconType: 'tiktok', name: 'TikTok' },
        'instagram': { iconType: 'instagram', name: 'Instagram' },
      };

      const sources = [];
      const lines = insightsText.split('\n');
      for (const line of lines) {
        const match = line.match(/(?:\d+\.\s*)?(?:\*\*)?([\w\s]+?)(?:\*\*)?\s*:\s*([\d.,]+)\s*konten/i);

        if (match) {
          const platformNameRaw = match[1].trim().toLowerCase();
          const countRaw = match[2].replace(/[.,]/g, '');
          const count = parseInt(countRaw, 10) || 0;

          const mappingKey = Object.keys(sourceMapping).find(key =>
            platformNameRaw.includes(key)
          );

          if (mappingKey) {
            const mapping = sourceMapping[mappingKey];
            sources.push({
              name: mapping.name,
              count: `${count.toLocaleString('id-ID')} entri`,
              iconType: mapping.iconType,
              rawCount: count
            });
          }
        }
      }

      sources.sort((a, b) => b.rawCount - a.rawCount);

      sources.forEach((src, i) => {
        src.rank = i + 1;
      });

      return sources;
    },
    createFirstPageHeader(doc, pageWidth, whiteBackground = false) {
      if (whiteBackground) {
        doc.setFillColor('#FFFFFF');
        doc.rect(8, 0, pageWidth - 6, 65, 'F');
      }

      doc.setFillColor('#25A853');
      doc.rect(0, 0, 17, 20, 'F');

      const now = new Date();
      const monthName = now.toLocaleString('en-US', { month: 'long' }).toUpperCase();
      const year = now.getFullYear();
      const headerDateText = `${monthName} ${year}`;

      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.setTextColor('#16A6A6');
      doc.text(headerDateText, 22, 12);

      const logoWidth = 50;
      const logoHeight = 16;

      const logoRightX = pageWidth - logoWidth - 8;

      if (typeof this.base64HeaderSolusi247 !== 'undefined' && this.base64HeaderSolusi247.length > 0) {
        doc.addImage(this.base64HeaderSolusi247, "PNG", logoRightX, 7, logoWidth, logoHeight);
      }

      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.setTextColor('#383838');
      const companyText = "TECHNOLOGY";
      const textCompanyY = 25;
      let textCompanyX = 22;
      const letterSpacing = 1.5;

      for (let i = 0; i < companyText.length; i++) {
        const char = companyText[i];
        doc.text(char, textCompanyX, textCompanyY);
        textCompanyX += doc.getTextWidth(char) + letterSpacing;
      }

      const textWidth = doc.getTextWidth(companyText) + (companyText.length - 1) * letterSpacing;
      const lineStartX = 20 + textWidth + 5;
      const lineY = textCompanyY;

      doc.setDrawColor('#C0C0C0');
      doc.setLineWidth(1);
      doc.line(lineStartX, lineY, pageWidth, lineY);

      doc.setFontSize(45);
      doc.setFont(undefined, 'bold');
      doc.setTextColor('#636363');
      const newsletterText = "NEWSLETTER";
      const textY = lineY + 18;
      let textX = 21;
      const letterSpacingNewsLetter = 2.7;

      for (let i = 0; i < newsletterText.length; i++) {
        const char = newsletterText[i];
        doc.text(char, textX, textY);
        textX += doc.getTextWidth(char) + letterSpacingNewsLetter;
      }
    },
    createStandardPageHeader(doc, pageWidth) {
      const now = new Date();
      const monthName = now.toLocaleString('en-US', { month: 'long' }).toUpperCase();
      const year = now.getFullYear();
      const headerDateText = `${monthName} ${year}`;

      const headerText = `${headerDateText} | SOLUSI247 NEWSLETTER`;

      const logoBase64 = this.base64HeaderSolusi247;
      const logoWidth = 50;
      const logoHeight = 15;
      const marginX = 15;
      const headerY = 15;
      const lineY = headerY + 5;

      doc.setFontSize(11);
      doc.setFont(undefined, "normal");
      doc.setTextColor("#555555");
      doc.text(headerText, marginX, headerY);

      const logoX = pageWidth - logoWidth - marginX;
      const logoY = headerY - 10;

      if (typeof logoBase64 !== "undefined" && logoBase64.length > 0) {
        doc.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
      }

      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.5);
      doc.line(marginX, lineY, pageWidth - marginX, lineY);
    },
    async renderHtmlToPdf(doc, htmlContent, startY, customMaxWidth = null, customXOffset = 10, dynamicFontSize = null) {
      let yOffset = startY;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const maxWidth = customMaxWidth || (pageWidth - 20);
      const xOffset = customXOffset;

      const isStaticFontSize = dynamicFontSize !== null;
      const baseFontSize = dynamicFontSize || 10.5;

      let currentFontSize = baseFontSize;
      let currentFontStyle = 'normal';
      let currentTextColor = '#000000';

      const addNewPage = () => {
        doc.addPage();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.setFillColor('#FFFFFF');
        doc.rect(0, 0, pageWidth, pageHeight, 'F');

        this.createStandardPageHeader(doc, pageWidth);

        let contentStartY = 30;

        const footerHeight = 15;
        const footerY = pageHeight - footerHeight;

        doc.setFillColor('#FFFFFF');
        doc.rect(0, footerY, pageWidth, footerHeight, 'F');

        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.setTextColor("#808080");
        const pageNumberX = 15;
        const pageNumberY = pageHeight - 8;
        doc.text(`HALAMAN ${this.pageNumberNewsletter}`, pageNumberX, pageNumberY);

        this.pageNumberNewsletter++;

        doc.setFontSize(currentFontSize);
        doc.setFont(undefined, currentFontStyle);
        doc.setTextColor(currentTextColor);

        return contentStartY;
      };

      const checkPageBreak = (requiredHeight = 15) => {
        if (yOffset + requiredHeight > pageHeight - 15) {
          yOffset = addNewPage();
          return true;
        }
        return false;
      };

      const parseTextWithStrong = (htmlText) => {
        const parts = [];
        const strongRegex = /<strong>(.*?)<\/strong>/g;
        let lastIndex = 0;
        let match;

        while ((match = strongRegex.exec(htmlText)) !== null) {
          if (match.index > lastIndex) {
            parts.push({
              text: htmlText.substring(lastIndex, match.index),
              bold: false
            });
          }
          parts.push({
            text: match[1],
            bold: true
          });
          lastIndex = match.index + match[0].length;
        }

        if (lastIndex < htmlText.length) {
          parts.push({
            text: htmlText.substring(lastIndex),
            bold: false
          });
        }

        return parts.length > 0 ? parts : [{ text: htmlText, bold: false }];
      };

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      const elements = tempDiv.children;

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const tagName = element.tagName.toLowerCase();
        const textContent = element.textContent || element.innerText || '';

        if (!textContent.trim() && tagName != 'table') continue;

        checkPageBreak();
        doc.setTextColor('#000000');

        switch (tagName) {
          case 'h1': {
            doc.setFontSize(16);
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#000000');
            yOffset += 5;
            const h1SplitText = doc.splitTextToSize(textContent, maxWidth);
            checkPageBreak(h1SplitText.length * 7);
            doc.text(h1SplitText, xOffset, yOffset);
            yOffset += h1SplitText.length * 7 + 2;
            break;
          }
          case 'h2': {
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#000000');
            yOffset += 4;
            const h2SplitText = doc.splitTextToSize(textContent, maxWidth);
            checkPageBreak(h2SplitText.length * 6);
            doc.text(h2SplitText, xOffset, yOffset);
            yOffset += h2SplitText.length * 6 + 2;
            break;
          }
          case 'h3': {
            doc.setFontSize(13);
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#000000');
            yOffset += 3;
            const h3SplitText = doc.splitTextToSize(textContent, maxWidth);
            checkPageBreak(h3SplitText.length * 6);
            doc.text(h3SplitText, xOffset, yOffset);
            yOffset += h3SplitText.length * 6 + 1;
            break;
          }
          case 'h4':
          case 'h5':
          case 'h6': {
            doc.setFontSize(12);
            doc.setFont(undefined, 'bold');
            doc.setTextColor('#000000');
            yOffset += 2;
            const hSplitText = doc.splitTextToSize(textContent, maxWidth);
            checkPageBreak(hSplitText.length * 6);
            doc.text(hSplitText, xOffset, yOffset);
            yOffset += hSplitText.length * 6 + 1;
            break;
          }
          case 'table': {
            yOffset += 2;
            yOffset = this.renderTableToPdf(doc, element, yOffset, maxWidth, checkPageBreak, xOffset);
            break;
          }
          case 'ol':
          case 'ul': {
            const listItems = element.querySelectorAll('li');
            let totalLines = 0;

            listItems.forEach((li) => {
              const liText = li.textContent || li.innerText || '';
              if (!liText.trim()) return;
              const splitText = doc.splitTextToSize(liText, maxWidth - 2);
              totalLines += splitText.length;
            });

            let currentFontSize = baseFontSize;
            if (!isStaticFontSize) {
              if (totalLines == 11) {
                currentFontSize = 11;
              } else if (totalLines > 11) {
                currentFontSize = Math.max(8, 11 - Math.floor((totalLines - 11) / 2));
              } else if (totalLines < 10) {
                currentFontSize = Math.min(14, 11 + (10 - totalLines));
              }
            }

            const lineHeight = currentFontSize * 0.35 + 1.8;
            const itemSpacing = 1.2;

            listItems.forEach((li, index) => {
              const liInnerHTML = li.innerHTML;
              const liText = li.textContent || li.innerText || '';
              if (!liText.trim()) return;

              doc.setFontSize(currentFontSize);
              const prefix = tagName == 'ol' ? `${index + 1}. ` : '• ';
              const prefixWidth = doc.getTextWidth(prefix);

              checkPageBreak(lineHeight * 3);

              doc.setFont(undefined, 'bold');
              doc.setTextColor("#215f5c");
              doc.text(prefix, xOffset, yOffset);

              const itemStartY = yOffset;
              const parts = parseTextWithStrong(liInnerHTML);
              let currentX = xOffset + prefixWidth;
              let itemYOffset = itemStartY;

              for (const part of parts) {
                if (!part.text.trim()) continue;

                doc.setFont(undefined, part.bold ? 'bold' : 'normal');
                doc.setTextColor("#000000");

                const partText = part.text.replace(/<[^>]*>/g, '').trim();
                const words = partText.split(/\s+/);

                for (let w = 0; w < words.length; w++) {
                  const word = words[w];
                  if (!word) continue;

                  const spaceWidth = doc.getTextWidth(' ');
                  const wordWidth = doc.getTextWidth(word);
                  const remainingWidth = xOffset + maxWidth - currentX;

                  if (currentX > xOffset + prefixWidth && wordWidth + spaceWidth > remainingWidth - 1) {
                    itemYOffset += lineHeight;
                    currentX = xOffset + prefixWidth;

                    doc.setFont(undefined, part.bold ? 'bold' : 'normal');
                    doc.setTextColor("#000000");
                  }

                  if (currentX > xOffset + prefixWidth) {
                    doc.text(' ', currentX, itemYOffset);
                    currentX += spaceWidth;
                  }

                  doc.text(word, currentX, itemYOffset);
                  currentX += wordWidth;
                }
              }

              yOffset = itemYOffset + lineHeight + itemSpacing;
            });

            yOffset += 1;
            break;
          }
          case 'p': {
            doc.setFontSize(baseFontSize);
            doc.setFont(undefined, 'normal');
            doc.setTextColor('#000000');
            const pInnerHTML = element.innerHTML;
            const parts = parseTextWithStrong(pInnerHTML);
            const lineHeight = baseFontSize * 0.45;
            let currentX = xOffset;

            for (const part of parts) {
              if (!part.text.trim()) continue;

              doc.setFont(undefined, part.bold ? 'bold' : 'normal');
              doc.setTextColor("#000000");

              const partText = part.text.replace(/<[^>]*>/g, '');
              const availableWidth = maxWidth - (currentX - xOffset);
              const splitText = doc.splitTextToSize(partText, availableWidth);

              checkPageBreak(splitText.length * lineHeight);

              for (let k = 0; k < splitText.length; k++) {
                if (k > 0) {
                  yOffset += lineHeight;
                  currentX = xOffset;

                  doc.setFont(undefined, part.bold ? 'bold' : 'normal');
                  doc.setTextColor("#000000");
                }
                doc.text(splitText[k], currentX, yOffset);
                if (k == splitText.length - 1) {
                  currentX += doc.getTextWidth(splitText[k]);
                }
              }
            }

            yOffset += lineHeight + 1;
            break;
          }
          default: {
            doc.setFontSize(12);
            doc.setFont(undefined, 'normal');
            doc.setTextColor('#000000');
            const splitText = doc.splitTextToSize(textContent, maxWidth);
            checkPageBreak(splitText.length * 5);
            doc.text(splitText, xOffset, yOffset);
            yOffset += splitText.length * 5 + 1;
            break;
          }
        }
      }

      tempDiv.remove();
      return yOffset;
    },
    formatTextReportDashboard(text) {
      if (!text) return '';

      let formatted = text
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .trim();

      formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      formatted = formatted.replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>');

      formatted = formatted
        .replace(/^#{1}\s+(.*)/gm, '<h1>$1</h1>')
        .replace(/^#{2}\s+\d+\.\s+(.*)/gm, '<h2>$1</h2>')
        .replace(/^#{2}\s+(.*)/gm, '<h2>$1</h2>')
        .replace(/^#{3}\s+(.*)/gm, '<h3>$1</h3>')
        .replace(/^#{4}\s+(.*)/gm, '<h4>$1</h4>')
        .replace(/^#{5}\s+(.*)/gm, '<h5>$1</h5>')
        .replace(/^#{6}\s+(.*)/gm, '<h6>$1</h6>');

      const lines = formatted.split('\n');
      let inOrderedList = false;
      let inUnorderedList = false;
      let inTable = false;
      let processedLines = [];
      let tableRows = [];
      let pendingHeaderRow = null;
      let currentParagraph = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();

        if (!line) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
            currentParagraph = [];
          }
          continue;
        }

        if (line.match(/^\|[-\s|:]+\|$/)) continue;

        if (line.startsWith('|') && line.endsWith('|') && line.includes('|')) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
            currentParagraph = [];
          }

          const cells = line.split('|').map(cell => cell.trim()).filter(cell => cell.length > 0);
          if (cells.length > 0) {
            if (!inTable) {
              if (inOrderedList) {
                processedLines.push('</ol>');
                inOrderedList = false;
              }
              if (inUnorderedList) {
                processedLines.push('</ul>');
                inUnorderedList = false;
              }
              inTable = true;
              tableRows = [];
              const nextLine = lines[i + 1];
              const isHeader = nextLine && nextLine.match(/^\|[-\s|:]+\|$/);
              if (isHeader) {
                pendingHeaderRow = cells;
              } else {
                tableRows.push(cells);
              }
            } else {
              tableRows.push(cells);
            }
            continue;
          }
        }

        if (inTable && line && !line.startsWith('|')) {
          processedLines.push('<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; width: 100%; margin: 10px 0;">');
          if (pendingHeaderRow) {
            processedLines.push('<thead><tr>');
            pendingHeaderRow.forEach(cell => {
              processedLines.push(`<th style="font-weight: bold; text-align: left; border: 1px solid #ddd; padding: 5px;">${cell}</th>`);
            });
            processedLines.push('</tr></thead>');
          }
          if (tableRows.length > 0) {
            processedLines.push('<tbody>');
            let expectedColumns = tableRows[0]?.length || 3;
            tableRows.forEach(row => {
              processedLines.push('<tr>');
              if (row.length < expectedColumns) {
                const missingCells = expectedColumns - row.length;
                for (let j = 0; j < missingCells; j++) {
                  processedLines.push(`<td style="text-align: left; border: 1px solid #ddd; padding: 5px;"></td>`);
                }
              }
              row.forEach(cell => {
                processedLines.push(`<td style="text-align: left; border: 1px solid #ddd; padding: 5px;">${cell}</td>`);
              });
              processedLines.push('</tr>');
            });
            processedLines.push('</tbody>');
          }
          processedLines.push('</table>');

          inTable = false;
          tableRows = [];
          pendingHeaderRow = null;
        }

        const numberedListMatch = line.match(/^(\d+)\.\s+(.*)$/);
        if (numberedListMatch) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
            currentParagraph = [];
          }
          if (inUnorderedList) {
            processedLines.push('</ul>');
            inUnorderedList = false;
          }
          if (!inOrderedList) {
            processedLines.push('<ol>');
            inOrderedList = true;
          }
          processedLines.push(`<li>${numberedListMatch[2]}</li>`);
          continue;
        }

        const bulletMatch = line.match(/^[-•]\s+(.*)$/);
        if (bulletMatch) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
            currentParagraph = [];
          }
          if (inOrderedList) {
            processedLines.push('</ol>');
            inOrderedList = false;
          }
          if (!inUnorderedList) {
            processedLines.push('<ul>');
            inUnorderedList = true;
          }
          processedLines.push(`<li>${bulletMatch[1]}</li>`);
          continue;
        }

        if (inOrderedList && !line.match(/^\d+\.\s+/)) {
          processedLines.push('</ol>');
          inOrderedList = false;
        }
        if (inUnorderedList && !line.match(/^[-•]\s+/)) {
          processedLines.push('</ul>');
          inUnorderedList = false;
        }

        if (line.match(/^<h[1-6]>.*<\/h[1-6]>$/)) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
            currentParagraph = [];
          }
          processedLines.push(line);
          continue;
        }

        if (line && !line.match(/^<h[1-6]>/) && !inOrderedList && !inUnorderedList && !inTable) {
          currentParagraph.push(line);
          continue;
        }

        if (line) {
          if (currentParagraph.length > 0) {
            processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
          }
          processedLines.push(`<p>${line}</p>`);
        }
      }

      if (currentParagraph.length > 0) {
        processedLines.push(`<p>${currentParagraph.join(' ')}</p>`);
      }

      if (inOrderedList) {
        processedLines.push('</ol>');
      }
      if (inUnorderedList) {
        processedLines.push('</ul>');
      }

      if (inTable) {
        processedLines.push('<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; width: 100%; margin: 10px 0;">');
        if (pendingHeaderRow) {
          processedLines.push('<thead><tr>');
          pendingHeaderRow.forEach(cell => {
            processedLines.push(`<th style="font-weight: bold; text-align: left; border: 1px solid #ddd; padding: 5px;">${cell}</th>`);
          });
          processedLines.push('</tr></thead>');
        }
        if (tableRows.length > 0) {
          processedLines.push('<tbody>');
          let expectedColumns = tableRows[0]?.length || 3;
          tableRows.forEach(row => {
            processedLines.push('<tr>');
            if (row.length < expectedColumns) {
              const missingCells = expectedColumns - row.length;
              for (let j = 0; j < missingCells; j++) {
                processedLines.push(`<td style="text-align: left; border: 1px solid #ddd; padding: 5px;"></td>`);
              }
            }
            row.forEach(cell => {
              processedLines.push(`<td style="text-align: left; border: 1px solid #ddd; padding: 5px;">${cell}</td>`);
            });
            processedLines.push('</tr>');
          });
          processedLines.push('</tbody>');
        }
        processedLines.push('</table>');
      }

      return processedLines.join('');
    },
    renderTableToPdf(doc, table, startY, pageWidth, checkPageBreak, customXOffset = 10) {
      let yOffset = startY;
      const rows = table.querySelectorAll('tr');

      if (rows.length == 0) return yOffset;

      const tableContext = this.getTableContext(table);
      const headerRow = rows[0];
      const headerCells = headerRow.querySelectorAll('th, td');
      const numCols = headerCells.length;
      let columnWidths = [];
      const availableWidth = pageWidth;
      const tableX = customXOffset;
      const cellPadding = 2;
      const rowHeight = 8;

      if (numCols == 5) {
        columnWidths = [
          availableWidth * 0.25,
          availableWidth * 0.1875,
          availableWidth * 0.1875,
          availableWidth * 0.1875,
          availableWidth * 0.1875
        ];
      } else if (numCols == 3 && tableContext.isMediaLineChart) {
        columnWidths = [
          availableWidth * 0.4,
          availableWidth * 0.3,
          availableWidth * 0.3
        ];
      } else if (numCols == 2 && tableContext.isMediaSummary) {
        columnWidths = [
          availableWidth * 0.7,
          availableWidth * 0.3
        ];
      } else {
        const colWidth = availableWidth / numCols;
        columnWidths = Array(numCols).fill(colWidth);
      }

      doc.setFontSize(11);
      rows.forEach((row) => {
        const cells = row.querySelectorAll('th, td');
        const isHeader = row.querySelector('th') !== null;
        checkPageBreak(rowHeight + 4);
        let currentX = tableX;

        for (let cellIndex = 0; cellIndex < numCols; cellIndex++) {
          const cell = cells[cellIndex];
          const cellWidth = columnWidths[cellIndex];
          const cellText = cell ? (cell.textContent || cell.innerText || '') : '';
          doc.setDrawColor(200, 200, 200);
          doc.rect(currentX, yOffset - rowHeight + 2, cellWidth, rowHeight);
          doc.setFont(undefined, isHeader ? 'bold' : 'normal');
          const maxWidth = cellWidth - (cellPadding * 2);
          let displayText = cellText;
          if (cellText) {
            const splitText = doc.splitTextToSize(cellText, maxWidth);
            displayText = splitText.length > 1 ? splitText[0] + '...' : splitText[0];
          }
          if (displayText) {
            doc.text(displayText, currentX + cellPadding, yOffset - 2);
          }
          currentX += cellWidth;
        }
        yOffset += rowHeight;
      });
      yOffset += 5;
      return yOffset;
    },
    getTableContext(table) {
      let element = table.previousElementSibling;
      let context = {
        isMediaLineChart: false,
        isMediaSummary: false,
        headingText: ''
      };

      while (element) {
        if (element.tagName && element.tagName.match(/^H[1-6]$/)) {
          const headingText = (element.textContent || element.innerText || '').toLowerCase();
          context.headingText = headingText;
          if (headingText.includes('media line chart') || headingText.includes('line chart')) {
            context.isMediaLineChart = true;
            break;
          } else if (headingText.includes('media summary') || headingText.includes('summary')) {
            context.isMediaSummary = true;
            break;
          } else if (headingText.includes('periodic crawled data')) {
            element = element.previousElementSibling;
            continue;
          } else if (headingText.length > 0) {
            break;
          }
        }
        element = element.previousElementSibling;
      }
      if (!context.isMediaLineChart && !context.isMediaSummary) {
        const headerRow = table.querySelector('tr');
        if (headerRow) {
          const headers = Array.from(headerRow.querySelectorAll('th, td')).map(cell =>
            (cell.textContent || cell.innerText || '').toLowerCase()
          );
          if (
            headers.length >= 4 &&
            headers.some(h => h.includes('tanggal') || h.includes('date')) &&
            (
              headers.some(h => h.includes('news')) ||
              headers.some(h => h.includes('twitter')) ||
              headers.some(h => h.includes('youtube')) ||
              headers.some(h => h.includes('tik tok'))
            )
          ) {
            context.isMediaLineChart = true;
          } else if (
            headers.length == 3 &&
            headers.some(h => h.includes('tanggal') || h.includes('date')) &&
            headers.some(h => h.includes('media')) &&
            headers.some(h => h.includes('nilai') || h.includes('value'))
          ) {
            context.isMediaLineChart = true;
          } else if (
            headers.length == 2 &&
            headers.some(h => h.includes('media')) &&
            headers.some(h => h.includes('nilai') || h.includes('value'))
          ) {
            context.isMediaSummary = true;
          }
        }
      }
      return context;
    },
    async insightsAICaptureAll() {
      try {
        const token = localStorage.getItem('token_app');

        try {
          const decodeResponse = await axios.post("decode-token", { token });

          if (!decodeResponse.data.valid) {
            throw { response: { status: 403 } };
          }
        } catch (e) {
          const { status } = e.response || {};

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
          return;
        }

        await this.parameterProsesTopicInsightAI();

        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const sentimentData = {
          negative: this.seriesDonut[1] || 0,
          positive: this.seriesDonut[2] || 0,
          neutral: this.seriesDonut[0] || 0,
          total: this.totalCollectedData || 0
        };

        const mediaLineChartData = this.seriesSentiment.map(series => {
          const mediaValues = series.data.map(item => ({
            date: item.x,
            media_value: [{
              value: item.y || 0,
              media: series.name
            }]
          }));
          return mediaValues;
        }).flat();

        const groupedByDate = {};
        mediaLineChartData.forEach(item => {
          if (!groupedByDate[item.date]) {
            groupedByDate[item.date] = {
              date: item.date,
              media_value: []
            };
          }
          groupedByDate[item.date].media_value.push(...item.media_value);
        });
        const formattedMediaLineChart = Object.values(groupedByDate);

        const mediaSummary = this.seriesSentiment.map(series => {
          const totalValue = series.data.reduce((sum, item) => sum + (item.y || 0), 0);
          return {
            media: series.name,
            value: totalValue
          };
        });

        const payload = {
          topic: this.selectedTopicTotalCollectedData,
          keyword: this.selectedKeyword == "All"
            ? this.topicKeywordSentimentInsightAI.filter(item => item != "All")
            : (
                this.topicKeywordSentimentInsightAI.includes(this.selectedKeyword)
                  ? [this.selectedKeyword]
                  : this.topicKeywordSentimentInsightAI.filter(item => item != "All")
              ),
          start_date: this.$store.date_start_glob,
          end_date: this.$store.date_end_glob,
          data: [
            {
              component_name: "Sentiment Analysis",
              data: sentimentData
            },
            {
              component_name: "Periodic Crawled Data",
              data: [
                {
                  item_name: "Media Line Chart",
                  item_data: formattedMediaLineChart
                },
                {
                  item_name: "Media Summary",
                  item_data: mediaSummary
                }
              ]
            }
          ]
        };

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v2/chat/generate-dashboard-report",
          payload
        );

        const dashboardReport = response.data.data.response;
        dashboardReport.forEach(item => {
          switch (item.format_type) {
            case "Ringkasan Eksekutif":
              this.ringkasanEksekutifInsights = item.response;
              break;
            case "Tren Opini Publik":
              this.trenOpiniPublikInsights = item.response;
              break;
            case "Sumber Informasi Utama":
              this.sumberInformasiUtamaInsights = item.response;
              break;
          }
        });
      } catch (error) {
        console.error("Error in postDescribeDashboardData:", error);
      }
    },
    async insightsAIContentAnalysis() {
      try {
        const token = localStorage.getItem("token_app");

        try {
          const decodeResponse = await axios.post("decode-token", { token });
          if (!decodeResponse.data.valid) throw { response: { status: 403 } };
        } catch (e) {
          const { status } = e.response || {};
          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
          return;
        }

        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: { Authorization: `Bearer ${token}` },
        });

        const payload = { query: this.newsletterTitle };

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v1/agentic/query",
          payload
        );

        this.contentAnalysisInsights = response.data.data.response;
      } catch (error) {
        this.contentAnalysisInsights = "The server is busy. Please try again later.";
        console.error("Error in insightsAIContentAnalysis:", error);
      }
    },
    regenerateInsight() {
      this.isRotatingRegenerateInsight = true;

      setTimeout(() => {
        this.isRotatingRegenerateInsight = false;
      }, 500);

      this.postDescribeDashboardData();
      this.dialogPageInsight = true;
    },
    async insightAIassistant() {
      trackEvent('dashboard-insight-ai');
      this.postDescribeDashboardData();
    },
    async postDescribeDashboardData() {
      this.dialogPageInsight = !this.dialogPageInsight;
      this.listResponseDescribeDashboard = [];
      this.currentLoadingIndex = 0;
      this.loadingResponseDescribeDashboard = true;

      try {
        const token = localStorage.getItem('token_app');
        try {
          const decodeResponse = await axios.post("decode-token", { token });

          if (!decodeResponse.data.valid) {
            throw { response: { status: 403 } };
          }
        } catch (e) {
          this.loadingResponseDescribeDashboard = false;
          const { status } = e.response || {};

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
          return;
        }

        await Promise.all([
          this.loadContentInsightAI(),
          this.parameterProsesTopicInsightAI()
        ]);

        const axiosInstance = axios.create({
          baseURL: "/apigenerativeAI",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const sentimentData = {
          negative: this.seriesDonut[1] || 0,
          positive: this.seriesDonut[2] || 0,
          neutral: this.seriesDonut[0] || 0,
          total: this.totalCollectedData || 0
        };

        const statisticsData = [
          {
            item_name: "Total Collected Data",
            item_value: this.totalCollectedData || 0,
            item_word: this.selectedTopicTotalCollectedData
          },
          {
            item_name: "Most Crawled Keyword",
            item_value: this.valueMostTotalKeyword?.count || 0,
            item_word: this.valueMostTotalKeyword?.name || ""
          },
          {
            item_name: "Least Crawled Keyword",
            item_value: this.valueLeastTotalKeyword?.count || 0,
            item_word: this.valueLeastTotalKeyword?.name || ""
          }
        ];

        const contentListData = [
          {
            sentiment: "Positive",
            percentage: this.beritaPositivePersen || 0,
            total_data: this.seriesDonut[2] || 0,
            contents: this.kontenBeritaAll
              .flat()
              .filter(item => item.sentiment == "Positive")
              .slice(0, 3)
              .map(item => ({
                title: item.title,
                content: item.content,
                url: item.url,
                media: item.source
              }))
          },
          {
            sentiment: "Negative",
            percentage: this.beritaNegativePersen || 0,
            total_data: this.seriesDonut[1] || 0,
            contents: this.kontenBeritaAll
              .flat()
              .filter(item => item.sentiment == "Negative")
              .slice(0, 3)
              .map(item => ({
                title: item.title,
                content: item.content,
                url: item.url,
                media: item.source
              }))
          },
          {
            sentiment: "Neutral",
            percentage: this.beritaNetralPersen || 0,
            total_data: this.seriesDonut[0] || 0,
            contents: this.kontenBeritaAll
              .flat()
              .filter(item => item.sentiment == "Neutral")
              .slice(0, 3)
              .map(item => ({
                title: item.title,
                content: item.content,
                url: item.url,
                media: item.source
              }))
          }
        ];

        const mediaLineChartData = this.seriesSentiment.map(series => {
          const mediaValues = series.data.map(item => ({
            date: item.x,
            media_value: [{
              value: item.y || 0,
              media: series.name
            }]
          }));
          return mediaValues;
        }).flat();

        const groupedByDate = {};
        mediaLineChartData.forEach(item => {
          if (!groupedByDate[item.date]) {
            groupedByDate[item.date] = {
              date: item.date,
              media_value: []
            };
          }
          groupedByDate[item.date].media_value.push(...item.media_value);
        });
        const formattedMediaLineChart = Object.values(groupedByDate);

        const mediaSummary = this.seriesSentiment.map(series => {
          const totalValue = series.data.reduce((sum, item) => sum + (item.y || 0), 0);
          return {
            media: series.name,
            value: totalValue
          };
        });

        const onlineNewsData = this.barChart?.xaxis?.categories?.map((category, index) => ({
          media_name: category,
          media_value: this.seriesBarOnlineNews[0]?.data[index] || 0
        })) || [];

        const socialMediaData = this.barChartSocialMedia?.xaxis?.categories?.map((category, index) => ({
          media_name: category,
          media_value: this.seriesBarSocialMedia[0]?.data[index] || 0
        })) || [];

        const payload = {
          topic: this.selectedTopicTotalCollectedData,
          keyword: this.selectedKeyword == "All"
            ? this.topicKeywordSentimentInsightAI.filter(item => item != "All")
            : (
                this.topicKeywordSentimentInsightAI.includes(this.selectedKeyword)
                  ? [this.selectedKeyword]
                  : this.topicKeywordSentimentInsightAI.filter(item => item != "All")
              ),
          start_date: this.$store.date_start_glob,
          end_date: this.$store.date_end_glob,
          data: [
            {
              component_name: "Sentiment Analysis",
              data: sentimentData
            },
            {
              component_name: "Statistics",
              data: statisticsData
            },
            {
              component_name: "Content List",
              data: contentListData
            },
            {
              component_name: "Periodic Crawled Data",
              data: [
                {
                  item_name: "Media Line Chart",
                  item_data: formattedMediaLineChart
                },
                {
                  item_name: "Media Summary",
                  item_data: mediaSummary
                }
              ]
            },
            {
              component_name: "Online News Portal",
              data: onlineNewsData
            },
            {
              component_name: "Social Media Channels",
              data: socialMediaData
            }
          ]
        };

        const response = await axiosInstance.post(
          "/gen-ai-medan/api/v1/chat/describe-dashboard-data",
          payload
        );

        const dashboardText = response.data.data.response;
        const lines = dashboardText.replace(/\r/g, '').split('\n');
        this.listResponseDescribeDashboard = [];

        let currentSection = "";
        let isInRincianKonten = false;

        lines.forEach((line, index) => {
          const trimmed = line.trim();
          if (!trimmed) return;

          const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
          if (headingMatch) {
            const level = headingMatch[1].length;
            const headingText = headingMatch[2];

            if (level == 2 && headingText.includes("Rincian Konten")) {
              if (currentSection) {
                this.listResponseDescribeDashboard.push(currentSection.trim());
              }
              currentSection = trimmed;
              isInRincianKonten = true;
            }
            else if (
              isInRincianKonten &&
              level == 3 &&
              (
                headingText.includes("Konten Positif") ||
                headingText.includes("Konten Negatif") ||
                headingText.includes("Konten Netral")
              )
            ) {
              currentSection += '\n' + trimmed;
            }
            else if (level <= 2) {
              if (currentSection) {
                this.listResponseDescribeDashboard.push(currentSection.trim());
                currentSection = "";
              }
              currentSection = trimmed;
              isInRincianKonten = false;
            } else {
              currentSection += '\n' + trimmed;
            }
          } else {
            currentSection += '\n' + trimmed;
          }

          if (index == lines.length - 1 && currentSection) {
            this.listResponseDescribeDashboard.push(currentSection.trim());
          }
        });

        const totalItems = this.listResponseDescribeDashboard.length;
        const interval = setInterval(() => {
          this.currentLoadingIndex++;
          if (this.currentLoadingIndex >= totalItems) {
            clearInterval(interval);
            this.loadingResponseDescribeDashboard = false;
          }
        }, 500);
      } catch (error) {
        console.error("Error in postDescribeDashboardData:", error);
        this.loadingResponseDescribeDashboard = false;
        this.listResponseDescribeDashboard = ["The server is busy. Please try again later."];
      }
    },
    formatTextDescribeDashboard(text) {
      if (!text) return "";

      const lines = text.split('\n');
      let htmlOutput = '';

      lines.forEach(line => {
        let trimmed = line.trim();
        if (!trimmed) return;

        trimmed = trimmed.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

        trimmed = trimmed.replace(/\*(.+?)\*/g, '<em>$1</em>');

        const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
          const level = headingMatch[1].length;
          const content = headingMatch[2];
          htmlOutput += `<h${level}>${content}</h${level}>`;
        } else if (/^\d+\./.test(trimmed)) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else if (trimmed.startsWith('- ')) {
          htmlOutput += `<p style="margin-bottom: 2px;">${trimmed}</p>`;
        } else {
          htmlOutput += `<p style="margin-bottom: 0px;">${trimmed}</p>`;
        }
      });

      return htmlOutput;
    },
    async loadContentInsightAI() {
      this.kontenBeritaAll = [];
      const listSentiment = ["Positive", "Neutral", "Negative"];
      for (let i = 0; i < listSentiment.length; i++) {
        try {
          const authToken = localStorage.getItem("token_app");
          if (!authToken) {
            throw new Error("Auth token not found");
          }

          const keywordRequestValue = encodeKeywordRequest(
            this.selectedKeywords,
            this.topicKeywordSentiment
          );

          const dataContent = await axios.post(
            `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${listSentiment[i]}&start=0&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const data = decryptionData(dataContent.data.token);
          this.kontenBeritaAll.push(data.data);
        } catch(e) {
          console.log(e);
        }
      }
    },
    async parameterProsesTopicInsightAI() {
      this.topicKeywordSentimentInsightAI = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopicInsightsAI) {
          this.topicKeywordSentimentInsightAI.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            this.topicKeywordSentimentInsightAI.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
    },
    handleMultipleKeyword(newVal) {
      const all = 'All';

      if (newVal.includes(all)) {
        if (newVal.length > 1) {
          this.selectedKeywords = newVal.filter(k => k != all);
        }
        if (newVal.length > 1 && newVal[newVal.length - 1] == "All") {
          this.selectedKeywords = [all];
        }
      } else {
        this.selectedKeywords = newVal;
      }
    },
    openDialogSearchContext() {
      this.dialogSearchContext = true;
      setTimeout(() => {
        this.dialogSearchContext = false;
      }, 10000);
    },
    getRealTimeData() {
      this.socket.on("listUpdate", fetchedData => {
        var s = fetchedData.replace(/\\n/g, "\\n")
                  .replace(/\\'/g, "\\'")
                  .replace(/\\"/g, '\\"')
                  .replace(/\\&/g, "\\&")
                  .replace(/\\r/g, "\\r")
                  .replace(/\\t/g, "\\t")
                  .replace(/\\b/g, "\\b")
                  .replace(/\\f/g, "\\f");
        var dataUpdate = JSON.parse(s);
        this.kontenBeritaAll = [];
        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        this.kontenBeritaAll = dataUpdate;
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Neutral") {
            this.kontenBeritaNetral.push(dataUpdate[i]);
          }
        }
        for (let i = 0; i < dataUpdate.length; i++) {
          if (dataUpdate[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(dataUpdate[i]);
          }
        }
        this.loadKontenBerita();
        this.updateSocket = true;
      })
    },
    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDateStart = dateString;

      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    async loadTopic() {
      this.isSearch = true;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const [keywordSelectResponse, topicKeywordResponse] = await Promise.all([
          axios.get("keyword_select", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          }),
          axios.get("topic-keyword", {
            headers: { 'auth-token': localStorage.getItem('token_app') },
            dataType: 'json'
          })
        ]);

        const dataDecryption = decryptionData(keywordSelectResponse.data.token);
        const data = dataDecryption.keyword;
        const collections = dataDecryption.collection;

        const topicKeywordData = decryptionData(topicKeywordResponse.data.token);
        const topicKeywordList = topicKeywordData.data.filter(item => item.GROUP_STATUS == 1);

        const completedTopicData = processTopicKeywords(data, collections, topicKeywordList);

        if (!data || data.length == 0) {
          this.listSourceCollection = collections;
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
          return;
        }

        for (let i = 0; i < completedTopicData.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob === undefined) {
              this.selectedTopic = completedTopicData[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicSentiment.push(completedTopicData[i]);
        }

        if (typeof this.selectedTopic === "string") {
          for (let i = 0; i < this.topicSentiment.length; i++) {
            if (this.selectedTopic == this.topicSentiment[i].TOPIC) {
              this.selectedTopic = this.topicSentiment[i].SEQ_ID;
              this.$store.topic_glob = this.selectedTopic;
            }
          }
        }

        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: completedTopicData,
        });

        this.topicKeywordSentiment = [];
        let all = "All";

        for (let i = 0; i < completedTopicData.length; i++) {
          if (completedTopicData[i].SEQ_ID == this.selectedTopic) {
            this.topicKeywordSentiment.push(all);

            for (let x = 0; x < completedTopicData[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                }
              }
              this.topicKeywordSentiment.push(completedTopicData[i].KEYWORD[x].KEYWORD);
            }

            this.selectedTopicTotalCollectedData = completedTopicData[i].TOPIC;
            this.selectedTopicInsightsAI = completedTopicData[i].SEQ_ID;
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;

        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generateFilterDate(periode);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob === undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }

        this.listSourceCollection = dataDecryption.collection;

        if (completedTopicData.length > 0) {
          this.loadChartPie();
        } else {
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.isSearch = false;
        }

        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;

        this.searchContextStartDate = this.dateStart;
        this.searchContextEndDate = this.dateEnd;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.isSearch = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      }
    },
    async parameterProsesTopic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topicKeywordSentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topicKeywordSentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 === undefined) {
                this.selectedKeyword = all;
              } else {
                this.selectedKeyword = this.$store.topic_glob2;
              }
            }
            this.topicKeywordSentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.selectedKeywords = ["All"];
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      if (this.selectedKeyword != "All") {
        this.selectedKeyword = "All";
      }
    },
    async parameterProsesKeyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameterProsesPeriode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generateFilterDate(periode);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });

      this.searchContextStartDate = date_start;
      this.searchContextEndDate = date_end;
      this.showPeriodeDate();
    },
    async parameterProsesCustom() {
      this.selectedPeriode = "Custom";

      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    filterBySentiment(event, chartContext, config) {
      const index = config.dataPointIndex;

      if (
        (index == 0 && this.statusFilter == "Neutral") ||
        (index == 1 && this.statusFilter == "Negative") ||
        (index == 2 && this.statusFilter == "Positive")
      ) {
        this.isClickSentiment = false;
        this.statusFilter = "";
        this.$store.commit("addButtonTmp", {
          sentiment_glob: "",
        });
      } else {
        this.isClickSentiment = true;
        if (index == 0) {
          this.statusFilter = "Neutral";
        }
        if (index == 1) {
          this.statusFilter = "Negative";
        }
        if (index == 2) {
          this.statusFilter = "Positive";
        }
      }

      this.loadChartPie();
    },
    loadSearchDashboard() {
      const selectedTopicObj = this.topicSentiment.find(topic => topic.SEQ_ID == this.selectedTopic);

      const selectedTopicName = selectedTopicObj ? selectedTopicObj.TOPIC : "";

      trackEvent('dashboard-search', {topic: selectedTopicName, keyword: this.selectedKeywords, sentiment: this.statusFilter, period: this.selectedPeriode});

      if (selectedTopicName != this.selectedTopicTotalCollectedData) {
        this.isClickSentiment = false;
        this.statusFilter = "";
        this.selectedSource = "";
        this.selectedSourceId = "";
      }

      this.loadChartPie();
    },
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
      });

      trackEvent("dashboard-search-reset");
      this.loadChartPie();
    },
    async loadChartPie() {
      this.alert = false;
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataChartPie = await axios.post(
          `dashboar-chart-sentiment?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.statusFilter}&start=0&rows=${this.pagePlay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        if (this.isClickSentiment == false) {
          this.seriesDonut = [
            dataChartPie.data.data.count_netral,
            dataChartPie.data.data.count_negative,
            dataChartPie.data.data.count_positive
          ]
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Neutral") {
            this.seriesDonut = [dataChartPie.data.data.count_netral, 0, 0];
          }
          if (this.statusFilter == "Negative") {
            this.seriesDonut = [0, dataChartPie.data.data.count_negative, 0];
          }
          if (this.statusFilter == "Positive") {
            this.seriesDonut = [0, 0, dataChartPie.data.data.count_positive];
          }
          window.dispatchEvent(new Event("resize"));
        }

        if (this.isClickSentiment == false) {
          this.valueTotalBerita = dataChartPie.data.data.count_news;
          this.valueTotalTweet = dataChartPie.data.data.count_twitter;
          this.valueTotalYoutube = dataChartPie.data.data.count_youtube;
          this.valueTotalTikTok = dataChartPie.data.data.count_tiktok;
          this.valueTotalInstagram = dataChartPie.data.data.count_instagram;
          this.valueTotalFacebook = dataChartPie.data.data.count_facebook;
          this.valueTotalThreads = dataChartPie.data.data.count_threads;
        }

        for (let i = 0; i < this.topicSentiment.length; i++) {
          if (this.topicSentiment[i].SEQ_ID == this.$store.topic_glob) {
            this.selectedTopicTotalCollectedData = this.topicSentiment[i].TOPIC;
            this.selectedTopicInsightsAI = this.topicSentiment[i].SEQ_ID;
          }
        }

        this.totalCollectedData = this.valueTotalBerita + this.valueTotalTweet + this.valueTotalYoutube + this.valueTotalTikTok + this.valueTotalInstagram + this.valueTotalFacebook + this.valueTotalThreads;

        if (this.isClickSentiment == false) {
          var countAll = dataChartPie.data.data.count_positive + dataChartPie.data.data.count_netral + dataChartPie.data.data.count_negative;
          const beritaPositivePersen = dataChartPie.data.data.count_positive / countAll * 100;
          this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
          this.beritaPositive = dataChartPie.data.data.count_positive;

          const beritaNetralPersen = dataChartPie.data.data.count_netral / countAll * 100;
          this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
          this.beritaNetral = dataChartPie.data.data.count_netral;

          const beritaNegativePersen = dataChartPie.data.data.count_negative / countAll * 100;
          this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
          this.beritaNegative = dataChartPie.data.data.count_negative;
          if (isNaN(beritaPositivePersen)) {
            this.beritaPositivePersen = 0;
          }
          if (isNaN(beritaNetralPersen)) {
            this.beritaNetralPersen = 0;
          }
          if (isNaN(beritaNegativePersen)) {
            this.beritaNegativePersen = 0;
          }
        }
        if (this.isClickSentiment == true) {
          if (this.statusFilter == "Positive") {
            let beritaPositivePersen = dataChartPie.data.data.count_positive / countAll * 100;
            this.beritaPositive = dataChartPie.data.data.count_positive;

            if (isNaN(beritaPositivePersen)) {
              beritaPositivePersen = 0;
            }

            if (beritaPositivePersen == 0 && this.beritaPositive == 0) {
              this.beritaPositivePersen = 0;
            } else {
              this.beritaPositivePersen = 100;
            }

            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Neutral") {
            let beritaNetralPersen = dataChartPie.data.data.count_netral / countAll * 100;
            this.beritaNetral = dataChartPie.data.data.count_netral;

            if (isNaN(beritaNetralPersen)) {
              beritaNetralPersen = 0;
            }

            if (beritaNetralPersen == 0 && this.beritaNetral == 0) {
              this.beritaNetralPersen = 0;
            } else {
              this.beritaNetralPersen = 100;
            }

            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNegativePersen = 0;
            this.beritaNegative = 0;
          }
          if (this.statusFilter == "Negative") {
            let beritaNegativePersen = dataChartPie.data.data.count_negative / countAll * 100;
            this.beritaNegative = dataChartPie.data.data.count_negative;

            if (isNaN(beritaNegativePersen)) {
              beritaNegativePersen = 0;
            }

            if (beritaNegativePersen == 0 && this.beritaNegative == 0) {
              this.beritaNegativePersen = 0;
            } else {
              this.beritaNegativePersen = 100;
            }

            this.beritaPositivePersen = 0;
            this.beritaPositive = 0;
            this.beritaNetralPersen = 0;
            this.beritaNetral = 0;
          }
        }

        let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
        if (maxSentiment == this.beritaPositive) {
          this.selectedTab = 0;
          this.tabsSentiment = "Positive";
        } else if (maxSentiment == this.beritaNetral) {
          this.selectedTab = 1;
          this.tabsSentiment = "Neutral";
        } else {
          this.selectedTab = 2;
          this.tabsSentiment = "Negative";
        }

        this.pagePositive = 1;
        this.pageNetral = 1;
        this.pageNegative = 1;
        this.pageLengthPositive = Math.ceil(dataChartPie.data.data.count_positive / this.pagePlay);
        this.pageLengthNetral = Math.ceil(dataChartPie.data.data.count_netral / this.pagePlay);
        this.pageLengthNegative = Math.ceil(dataChartPie.data.data.count_negative / this.pagePlay);

        window.dispatchEvent(new Event("resize"));

        this.loadMostLeastCrawler();

        if (dataChartPie.data.data.count_positive == 0 && dataChartPie.data.data.count_netral == 0 && dataChartPie.data.data.count_negative == 0) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Sentiment Response Data Not Found";
          this.colorAlert = "red";
        }
      } catch(e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Sentiment Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    async loadMostLeastCrawler() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataMostLeastKeyword = await axios.post(
          `most-least-crawler?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.statusFilter}&start=0&rows=${this.pagePlay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataMostLeastKeyword.data.token);

        const cleanKeyword = (keyword) => {
          if (keyword.includes(' or ')) {
            const mainPart = keyword.split(' or ')[0];
            return mainPart
              .replace(/(comment_full_text|clean_text|text|content|title|user_post_desc|caption):/g, "")
              .replace(/~2/g, "")
              .replace(/"/g, "")
              .trim();
          }

          return keyword
            .replace(/(comment_full_text|clean_text|text|content|title|user_post_desc|caption):/g, "")
            .replace(/~2/g, "")
            .replace(/"/g, "")
            .trim();
        };

        const mergeCrawlerData = (crawlerArray, combinedData) => {
          if (Array.isArray(crawlerArray) && crawlerArray.length) {
            crawlerArray.forEach((item) => {
              if (item.most) {
                Object.entries(item.most).forEach(([name, count]) => {
                  const cleanName = cleanKeyword(name);
                  combinedData[cleanName] = (combinedData[cleanName] || 0) + count;
                });
              }
            });
          }
        };

        const combinedData = {};

        mergeCrawlerData(data.most_crawler, combinedData);
        mergeCrawlerData(data.most_crawlerTwitter, combinedData);
        mergeCrawlerData(data.most_crawlerYoutube, combinedData);
        mergeCrawlerData(data.most_crawlerInstagram, combinedData);
        mergeCrawlerData(data.most_crawlerTikTok, combinedData);

        const combinedArray = Object.entries(combinedData).map(([name, count]) => ({ name, count }));

        const mostFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count > current.count ? prev : current)) : { name: "-", count: 0 };
        const leastFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count < current.count ? prev : current)) : { name: "-", count: 0 };

        this.valueMostTotalKeyword = mostFrequent;
        this.valueLeastTotalKeyword = leastFrequent;

        const sortedArray = combinedArray.sort((a, b) => b.count - a.count);

        this.top3Keywords = sortedArray.slice(0, 3);

        this.loadChartArea();
      } catch (e) {
        console.error(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        this.message = "API Most Least Crawler Response Data Not Found";
        this.colorAlert = "red";
        setTimeout(() => {
          this.alert = false;
        }, 10000);
      }
    },
    async loadChartArea() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        if (this.isSearch == true) {
          this.rowsChartArea = this.valueTotalBerita;
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataChartArea = await axios.post(
          `dashboard-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.statusFilter}&start=0&rows=${this.rowsChartArea}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        this.processData(dataChartArea.data.data);

        if (this.selectedKeywords[0] == "All") {
          this.topicSpecificKeyword = this.topicKeywordSentiment.filter(k => k != "" && k !== null && k !== undefined);
          this.selectedAddSpecificKeyword = ["All"];
          this.seriesSpecificKeyword = [];
          this.listValueSpecificKeyword = [];
          this.prevSelectedAddSpecificKeyword = "";
          this.startIndexSpecificKeyword = 0;
          this.processDataSpecificKeyword(dataChartArea.data.data);
        } else {
          this.topicSpecificKeyword = this.selectedKeywords;
          this.selectedAddSpecificKeyword = this.topicSpecificKeyword;
          this.seriesSpecificKeyword = [];
          this.listValueSpecificKeyword = [];
          this.prevSelectedAddSpecificKeyword = [...this.selectedAddSpecificKeyword];
          this.startIndexSpecificKeyword = 0;

          for (const keyword of this.selectedAddSpecificKeyword) {
            try {
              const dataChartArea = await axios.post(
                `dashboard-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keyword}&sentiment=${this.statusFilter}&start=0&rows=${this.rowsChartArea}`,
                {},
                {
                  headers: {
                    'auth-token': authToken,
                  },
                }
              );
              this.processDataSpecificKeyword(dataChartArea.data.data, keyword);
            } catch (error) {
              console.error(`Error loading data for specific keyword: ${keyword}`, error);
            }
          }
        }
      } catch(e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Area Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    processData(data) {
      const combinedData = {};
      const platforms = ["date_mediaonline", "date_twitter", "date_youtube", "date_tiktok", "date_instagram"];
      const platformNames = ["News", "Twitter", "Youtube", "Tik Tok", "Instagram"];

      this.seriesSentiment = [];
      const categories = [];

      const aggregateData = (platformData, platformName, seriesIndex) => {
        platformData.forEach((item) => {
          const date = item.date;
          if (!combinedData[date]) {
            combinedData[date] = { date: new Date(date).getTime(), counts: [] };
          }
          if (!combinedData[date].counts[seriesIndex]) {
            combinedData[date].counts[seriesIndex] = 0;
          }
          combinedData[date].counts[seriesIndex] += item.Total;
        });
      };

      const platformColors = {
        News: '#6F6F6F',
        Twitter: '#FFB000',
        Instagram: '#814AD6',
        'Tik Tok': '#000',
        Youtube: '#B87333',
      };

      let selectedColors = [];

      if (this.selectedSource == "") {
        platforms.forEach((platformKey, index) => {
          const platformData = data[platformKey] || [];
          aggregateData(platformData, platformNames[index], index);

          const isPlatformExists = this.listSourceCollection.some(
            (item) => item.NAME_SOCIAL_MEDIA == platformNames[index]
          );

          if (isPlatformExists) {
            this.seriesSentiment.push({
              name: platformNames[index],
              data: [],
            });

            if (platformColors[platformNames[index]]) {
              selectedColors.push(platformColors[platformNames[index]]);
            }
          }
        });

        const categoriesSet = new Set(Object.keys(combinedData));
        const sortedCategories = Array.from(categoriesSet).sort();

        sortedCategories.forEach((category) => {
          categories.push(new Date(category).getTime());
          platforms.forEach((platformKey, index) => {
            const formattedDate = this.formatDate(category);
            const count = combinedData[category]?.counts[index] || 0;

            const sentimentIndex = this.seriesSentiment.findIndex(
              (s) => s.name == platformNames[index]
            );

            if (sentimentIndex != -1) {
              this.seriesSentiment[sentimentIndex].data.push({
                x: formattedDate,
                y: count,
              });
            }
          });
        });

        this.sentimentAnalysis.xaxis.categories = categories;
      } else {
        const selectedPlatformKey = `date_${this.selectedSource.toLowerCase()}`;
        const selectedPlatformData = data[selectedPlatformKey] || [];

        this.seriesSentiment = [
          { name: "Positive", data: [] },
          { name: "Neutral", data: [] },
          { name: "Negative", data: [] },
        ];

        selectedPlatformData.forEach((item) => {
          const date = item.date;
          const formattedDate = this.formatDate(date);

          this.seriesSentiment[0].data.push({ x: formattedDate, y: item.Positive });
          this.seriesSentiment[1].data.push({ x: formattedDate, y: item.Neutral });
          this.seriesSentiment[2].data.push({ x: formattedDate, y: item.Negative });
        });

        selectedColors = ['#00E396', '#008FFB', '#FF4560'];

        let countPositive = "";
        let countNetral = "";
        let countNegative = "";
        if (this.seriesSentiment[0] && this.seriesSentiment[0].data) {
          countPositive = this.seriesSentiment[0].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriesSentiment[1] && this.seriesSentiment[1].data) {
          countNetral = this.seriesSentiment[1].data.reduce((sum, item) => sum + item.y, 0);
        }
        if (this.seriesSentiment[2] && this.seriesSentiment[2].data) {
          countNegative = this.seriesSentiment[2].data.reduce((sum, item) => sum + item.y, 0);
        }

        var countAll = countPositive + countNetral + countNegative;
        const beritaPositivePersen = countPositive / countAll * 100;
        this.beritaPositivePersen = parseFloat(beritaPositivePersen.toFixed(2));
        this.beritaPositive = countPositive;

        const beritaNetralPersen = countNetral / countAll * 100;
        this.beritaNetralPersen = parseFloat(beritaNetralPersen.toFixed(2));
        this.beritaNetral = countNetral;

        const beritaNegativePersen = countNegative / countAll * 100;
        this.beritaNegativePersen = parseFloat(beritaNegativePersen.toFixed(2));
        this.beritaNegative = countNegative;
        if (isNaN(beritaPositivePersen)) {
          this.beritaPositivePersen = 0;
        }
        if (isNaN(beritaNetralPersen)) {
          this.beritaNetralPersen = 0;
        }
        if (isNaN(beritaNegativePersen)) {
          this.beritaNegativePersen = 0;
        }

        this.pagePositive = 1;
        this.pageNetral = 1;
        this.pageNegative = 1;
        this.pageLengthPositive = Math.ceil(countPositive / this.pagePlay);
        this.pageLengthNetral = Math.ceil(countNetral / this.pagePlay);
        this.pageLengthNegative = Math.ceil(countNegative / this.pagePlay);
      }

      this.sentimentAnalysis = {
        ...this.sentimentAnalysis,
        colors: selectedColors,
      };

      if (this.isClickSentiment == true) {
        if (this.changeBackgroundColor == false) {
          const sumTotals = (items) => {
            if (!items || !Array.isArray(items)) return 0;
            return items.reduce((sum, item) => sum + (item.Total || 0), 0);
          };

          this.valueTotalBerita = sumTotals(data.date_mediaonline);
          this.valueTotalTweet = sumTotals(data.date_twitter);
          this.valueTotalYoutube = sumTotals(data.date_youtube);
          this.valueTotalInstagram = sumTotals(data.date_instagram);
          this.valueTotalTikTok = sumTotals(data.date_tiktok);
          this.valueTotalFacebook = sumTotals(data.date_facebook);
          this.valueTotalThreads = sumTotals(data.date_threads);

        }
        this.totalCollectedData = this.valueTotalBerita + this.valueTotalTweet + this.valueTotalYoutube + this.valueTotalTikTok + this.valueTotalInstagram + this.valueTotalFacebook + this.valueTotalThreads;
      }

      if (this.beritaPositive == 0 && this.beritaNetral == 0 && this.beritaNegative == 0) {
        this.tabsSentiment = this.statusFilter;
      } else {
        let maxSentiment = Math.max(this.beritaPositive, this.beritaNetral, this.beritaNegative);
        if (maxSentiment == this.beritaPositive) {
          this.selectedTab = 0;
          this.tabsSentiment = "Positive";
        } else if (maxSentiment == this.beritaNetral) {
          this.selectedTab = 1;
          this.tabsSentiment = "Neutral";
        } else {
          this.selectedTab = 2;
          this.tabsSentiment = "Negative";
        }
      }

      this.loadContent();
    },
    async handleAddSpecificKeyword() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const currentSelected = this.selectedAddSpecificKeyword;
        const prevSelected = Array.isArray(this.prevSelectedAddSpecificKeyword) && this.prevSelectedAddSpecificKeyword.length > 0
          ? this.prevSelectedAddSpecificKeyword
          : (this.seriesSpecificKeyword.length > 0 ? this.seriesSpecificKeyword.map(s => s.name) : []);

        const removed = prevSelected.filter((x) => !currentSelected.includes(x));
        const added = currentSelected.filter((x) => !prevSelected.includes(x));
        this.prevSelectedAddSpecificKeyword = [...currentSelected];

        if (removed.length > 0) {
          removed.forEach((keyword) => {
            this.seriesSpecificKeyword = this.seriesSpecificKeyword.filter(
              (s) => s.name != keyword
            );
            this.listValueSpecificKeyword = this.listValueSpecificKeyword.filter(
              (v) => v.name != keyword
            );
          });

          if (this.seriesSpecificKeyword.length > 0) {
            this.optionSpecificKeyword = {
              ...this.optionSpecificKeyword,
              colors: this.generateColors(this.seriesSpecificKeyword.length),
              legend: {
                ...this.optionSpecificKeyword.legend,
                show: true,
                showForSingleSeries: true
              }
            };
          } else {
            this.seriesSpecificKeyword = [];
            this.listValueSpecificKeyword = [];
            this.optionSpecificKeyword = {
              ...this.optionSpecificKeyword,
              legend: {
                ...this.optionSpecificKeyword.legend,
                show: false
              }
            };
          }
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          return;
        }

        if (added.length > 0) {
          const specificKeyword = added[added.length - 1];

          const authToken = localStorage.getItem("token_app");
          if (!authToken) {
            throw new Error("Auth token not found");
          }

          const keywordRequestValue = encodeKeywordRequest(
            specificKeyword,
            this.topicKeywordSentiment
          );

          const dataChartArea = await axios.post(
            `dashboard-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.statusFilter}&start=0&rows=${this.rowsChartArea}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          if (specificKeyword == "All") {
            this.processDataSpecificKeyword(dataChartArea.data.data, null);
          } else {
            this.processDataSpecificKeyword(dataChartArea.data.data, specificKeyword);
          }
        }
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (e) {
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        if (e.response) {
          const { status } = e.response;
          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Area Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    processDataSpecificKeyword(data, specificKeyword = null) {
      if (!data) return;

      if (this.selectedSource == "") {
        const totalsByDate = {};

        Object.keys(data).forEach((key) => {
          if (!key.startsWith("date_")) return;

          data[key].forEach((item) => {
            if (!totalsByDate[item.date]) {
              totalsByDate[item.date] = 0;
            }
            totalsByDate[item.date] += item.Total;
          });
        });

        const sortedDates = Object.keys(totalsByDate).sort();

        if (!Array.isArray(this.listValueSpecificKeyword)) {
          this.listValueSpecificKeyword = [];
        }

        if (specificKeyword === null) {
          const allSeries = {
            name: "All",
            data: sortedDates.map((date) => ({
              x: date,
              y: totalsByDate[date],
            })),
          };

          const totalCount = allSeries.data.reduce((sum, item) => sum + item.y, 0);

          const existingAllSeriesIndex = this.seriesSpecificKeyword.findIndex(s => s.name == "All");
          const existingAllListIndex = this.listValueSpecificKeyword.findIndex(v => v.name == "All");

          if (existingAllSeriesIndex != -1) {
            this.seriesSpecificKeyword[existingAllSeriesIndex] = allSeries;
          } else {
            this.seriesSpecificKeyword.push(allSeries);
          }

          if (existingAllListIndex != -1) {
            this.listValueSpecificKeyword[existingAllListIndex].count = totalCount;
          } else {
            this.listValueSpecificKeyword.push({ count: totalCount, name: "All" });
          }
        }

        if (specificKeyword) {
          const existingSeriesIndex = this.seriesSpecificKeyword.findIndex(
            (s) => s.name == specificKeyword
          );
          const existingListIndex = this.listValueSpecificKeyword.findIndex(
            (v) => v.name == specificKeyword
          );

          const totalsByDateKeyword = {};

          Object.keys(data).forEach((key) => {
            if (!key.startsWith("date_")) return;

            data[key].forEach((item) => {
              if (!totalsByDateKeyword[item.date]) {
                totalsByDateKeyword[item.date] = 0;
              }
              totalsByDateKeyword[item.date] += item.Total;
            });
          });

          const baseDates = this.seriesSpecificKeyword.length > 0
            ? this.seriesSpecificKeyword[0].data.map((d) => d.x)
            : sortedDates;

          const keywordSeries = {
            name: specificKeyword,
            data: baseDates.map((date) => ({
              x: date,
              y: totalsByDateKeyword[date] || 0,
            })),
          };

          const totalCount = keywordSeries.data.reduce((sum, item) => sum + item.y, 0);

          if (existingSeriesIndex != -1) {
            this.seriesSpecificKeyword[existingSeriesIndex] = keywordSeries;
          } else {
            this.seriesSpecificKeyword.push(keywordSeries);
          }

          if (existingListIndex != -1) {
            this.listValueSpecificKeyword[existingListIndex].count = totalCount;
          } else {
            this.listValueSpecificKeyword.push({ count: totalCount, name: keywordSeries.name });
          }
        }
      } else {
        const selectedPlatformKey = `date_${this.selectedSource.toLowerCase()}`;
        const selectedPlatformData = data[selectedPlatformKey] || [];

        const totalsByDate = {};
        selectedPlatformData.forEach((item) => {
          if (!totalsByDate[item.date]) {
            totalsByDate[item.date] = 0;
          }
          totalsByDate[item.date] += item.Total;
        });

        const sortedDates = Object.keys(totalsByDate).sort();

        if (!Array.isArray(this.listValueSpecificKeyword)) {
          this.listValueSpecificKeyword = [];
        }

        if (specificKeyword === null) {
          const allSeries = {
            name: "All",
            data: sortedDates.map((date) => ({
              x: date,
              y: totalsByDate[date],
            })),
          };

          const totalCount = allSeries.data.reduce((sum, item) => sum + item.y, 0);

          const existingAllSeriesIndex = this.seriesSpecificKeyword.findIndex(s => s.name == "All");
          const existingAllListIndex = this.listValueSpecificKeyword.findIndex(v => v.name == "All");

          if (existingAllSeriesIndex != -1) {
            this.seriesSpecificKeyword[existingAllSeriesIndex] = allSeries;
          } else {
            this.seriesSpecificKeyword.push(allSeries);
          }

          if (existingAllListIndex != -1) {
            this.listValueSpecificKeyword[existingAllListIndex].count = totalCount;
          } else {
            this.listValueSpecificKeyword.push({ count: totalCount, name: "All" });
          }
        }

        if (specificKeyword) {
          const existingSeriesIndex = this.seriesSpecificKeyword.findIndex(
            (s) => s.name == specificKeyword
          );
          const existingListIndex = this.listValueSpecificKeyword.findIndex(
            (v) => v.name == specificKeyword
          );

          const totalsByDateKeyword = {};
          selectedPlatformData.forEach((item) => {
            if (!totalsByDateKeyword[item.date]) {
              totalsByDateKeyword[item.date] = 0;
            }
            totalsByDateKeyword[item.date] += item.Total;
          });

          const baseDates = this.seriesSpecificKeyword.length > 0
            ? this.seriesSpecificKeyword[0].data.map((d) => d.x)
            : sortedDates;

          const keywordSeries = {
            name: specificKeyword,
            data: baseDates.map((date) => ({
              x: date,
              y: totalsByDateKeyword[date] || 0,
            })),
          };

          const totalCountKeyword = keywordSeries.data.reduce((sum, item) => sum + item.y, 0);

          if (existingSeriesIndex != -1) {
            this.seriesSpecificKeyword[existingSeriesIndex] = keywordSeries;
          } else {
            this.seriesSpecificKeyword.push(keywordSeries);
          }

          if (existingListIndex != -1) {
            this.listValueSpecificKeyword[existingListIndex].count = totalCountKeyword;
          } else {
            this.listValueSpecificKeyword.push({ count: totalCountKeyword, name: keywordSeries.name });
          }
        }
      }

      this.listValueSpecificKeyword.sort((a, b) => b.count - a.count);

      this.optionSpecificKeyword = {
        ...this.optionSpecificKeyword,
        legend: {
          ...this.optionSpecificKeyword.legend,
          show: this.seriesSpecificKeyword.length > 0,
          showForSingleSeries: true
        },
        colors: this.generateColors(this.seriesSpecificKeyword.length),
      };
    },
    prevSlideSpecificKeyword() {
      if (this.startIndexSpecificKeyword > 0) {
        this.startIndexSpecificKeyword--;
      }
    },
    nextSlideSpecificKeyword() {
      if (this.startIndexSpecificKeyword + this.maxVisibleSpecificKeyword < this.listValueSpecificKeyword.length) {
        this.startIndexSpecificKeyword++;
      }
    },
    generateColors(count) {
      const defaultColors = [
        "#6F6F6F", "#FFB000", "#814AD6", "#000", "#B87333",
        "#bd0ca0", "#F4A261", "#e9c46a", "#B784A7", "#b9a389",
        "#E5989B", "#E76F51", "#7B2CBF", "#D4A373", "#B56576",
        "#5A189A", "#A98467", "#C05746", "#F28482", "#6A0572",
        "#A44A3F", "#A06CD5", "#C6A75E", "#D08C60", "#915F6D"
      ];

      if (count <= defaultColors.length) {
        return defaultColors;
      }

      const extraNeeded = count - defaultColors.length;
      const extraColors = [];

      for (let i = 0; i < extraNeeded; i++) {
        const hue = Math.floor((360 / extraNeeded) * i);
        extraColors.push(`hsl(${hue}, 70%, 50%)`);
      }

      return [...defaultColors, ...extraColors];
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    async loadContent() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataContent = await axios.post(
          `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=0&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.token);

        this.kontenBeritaPositive = [];
        this.kontenBeritaNetral = [];
        this.kontenBeritaNegative = [];
        const content = data.data;

        content.forEach(item => {
          if (item.sentiment == "Positive") {
            this.kontenBeritaPositive.push(item);
          }
          if (item.sentiment == "Neutral") {
            this.kontenBeritaNetral.push(item);
          }
          if (item.sentiment == "Negative") {
            this.kontenBeritaNegative.push(item);
          }
        });

        this.newsMediaChannel();
      } catch(e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API Dashboard Content Response Data Not Found";
        this.colorAlert = "red";
      }
    },
    async newsMediaChannel() {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataNewsMediaChannel = await axios.post(
          `news-media-channel?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.statusFilter}&start=0&rows=${this.pagePlay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataNewsMediaChannel.data.token);

        this.seriesBarOnlineNews[0].data = [];
        this.barChart = {
          colors: ['#38BABC', '#16A5A7', '#079092'],
          chart: {
            height: 300,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                fontSize: '12px'
              },
              show: true,
              rotate: -45,
              rotateAlways: true,
              hideOverlappingLabels: false,
              trim: false,
              maxHeight: 120
            },
            tickAmount: 'dataPoints'
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return '<div class="custom-tooltip">' +
                '<span>' + w.config.xaxis.categories[dataPointIndex] + '</span>' +
                '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
                '</div>';
            }
          }
        };

        if (data.news_portal && data.news_portal.length > 0) {
          const combinedMap = new Map();

          data.news_portal.forEach(portal => {
            if (portal.data && portal.data.length > 0) {
              portal.data.forEach(item => {
                if (combinedMap.has(item.name)) {
                  combinedMap.get(item.name).count += item.count;
                } else {
                  combinedMap.set(item.name, { ...item });
                }
              });
            }
          });

          const combinedArray = Array.from(combinedMap.values())
            .sort((a, b) => b.count - a.count)
            .slice(0, 10);

          combinedArray.forEach((val, key) => {
            this.seriesBarOnlineNews[0].data[key] = val.count;
            this.barChart.xaxis.categories[key] = val.name;
          });
        }

        this.seriesBarSocialMedia = [{ data: [] }];
        this.barChartSocialMedia = {
          colors: ['#38BABC', '#16A5A7', '#079092'],
          chart: {
            height: 300,
            type: 'bar',
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              columnWidth: '45%',
              distributed: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return '<div class="custom-tooltip">' +
                '<span>' + (w.config.xaxis.categories[dataPointIndex] || '') + '</span>' +
                '<span> Count: ' + series[seriesIndex][dataPointIndex] + '</span>' +
                '</div>';
            }
          }
        };

        if (
          this.valueTotalTweet != 0 ||
          this.valueTotalYoutube != 0 ||
          this.valueTotalInstagram != 0 ||
          this.valueTotalTikTok != 0 ||
          this.valueTotalFacebook != 0 ||
          this.valueTotalThreads != 0
        ) {
          const filteredListSourceCollection = this.listSourceCollection.filter(item => item.NAME_SOCIAL_MEDIA != "News");
          const pairedData = filteredListSourceCollection.map(item => {
            switch (item.NAME_SOCIAL_MEDIA) {
              case "Twitter":   return { name: "Twitter",   value: this.valueTotalTweet };
              case "Youtube":   return { name: "YouTube",   value: this.valueTotalYoutube };
              case "Instagram": return { name: "Instagram", value: this.valueTotalInstagram };
              case "Tik Tok":   return { name: "Tik Tok",   value: this.valueTotalTikTok };
              case "Facebook":  return { name: "Facebook",  value: this.valueTotalFacebook };
              case "Threads":  return { name: "Threads",  value: this.valueTotalThreads };
              default:          return null;
            }
          }).filter(Boolean);

          pairedData.sort((a, b) => b.value - a.value);

          this.seriesBarSocialMedia[0].data = [];
          pairedData.forEach((item, key) => {
            this.barChartSocialMedia.xaxis.categories[key] = item.name;
            this.seriesBarSocialMedia[0].data.push(item.value);
          });
        }

        window.dispatchEvent(new Event("resize"));

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch(e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 10000);
        this.message = "API News Media Channel Response Data Not Found";
        this.colorAlert = "red";
      }

      if (this.isSearch == true) {
        this.openDialogSearchContext();
      }

      this.isSearch = false;
    },
    async contentListSentiment(sentiment) {
      this.tabsSentiment = sentiment;

      if (this.isClickSentiment == false) {
        this.overlayDialogLoading = true;
        this.dialogLoading = true;

        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        try {
          const dataContent = await axios.post(
            `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${sentiment}&start=0&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
            {},
            {
              headers: {
                'auth-token': authToken,
              },
            }
          );

          const data = decryptionData(dataContent.data.token);
          this.kontenBeritaPositive = [];
          this.kontenBeritaNetral = [];
          this.kontenBeritaNegative = [];
          const content = data.data;

          content.forEach(item => {
            if (sentiment == "Positive") {
              this.kontenBeritaPositive.push(item);
            }
            if (sentiment == "Neutral") {
              this.kontenBeritaNetral.push(item);
            }
            if (sentiment == "Negative") {
              this.kontenBeritaNegative.push(item);
            }
          });
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
        } catch(e) {
          console.log(e);
          this.overlayDialogLoading = false;
          this.dialogLoading = false;
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Content Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },
    async handlePageChangePositive(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pagePlay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataContent = await axios.post(
          `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.token);
        this.kontenBeritaPositive = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Positive") {
            this.kontenBeritaPositive.push(data.data[i]);
          }
        }

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    async handlePageChangeNetral(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pagePlay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataContent = await axios.post(
          `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.token);
        this.kontenBeritaNetral = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Neutral") {
            this.kontenBeritaNetral.push(data.data[i]);
          }
        }

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
    async handlePageChangeNegative(value) {
      this.overlayDialogLoading = true;
      this.dialogLoading = true;

      const startPage = this.pagePlay * (value - 1);

      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        const keywordRequestValue = encodeKeywordRequest(
          this.selectedKeywords,
          this.topicKeywordSentiment
        );

        const dataContent = await axios.post(
          `dashboar-content?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keywordRequestValue}&sentiment=${this.tabsSentiment}&start=${startPage}&rows=${this.pagePlay}&sourceCollection=${this.selectedSourceId}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(dataContent.data.token);
        this.kontenBeritaNegative = [];
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].sentiment == "Negative") {
            this.kontenBeritaNegative.push(data.data[i]);
          }
        }

        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      } catch (e) {
        console.log(e);
        this.overlayDialogLoading = false;
        this.dialogLoading = false;
      }
    },
  }
}
</script>

<style scoped>
.drop-zone-image-newsletter {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-image-newsletter:hover {
  border: 2px solid var(--color-theme-secondary);
}
.drop-zone-image-newsletter:hover .drop-zone-image-newsletter-title {
  color: var(--color-theme-secondary);
}
.drop-zone-image-newsletter-over {
  background: #5c5c5c;
  opacity: 0.8;
}
.drop-zone-image-newsletter input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
}
.drop-zone-image-newsletter-info {
  position: absolute;
  top: 50%;
  width: 100%;
  color: #a8a8a8;
  text-align: center;
  transform: translate(0, -50%);
}
.drop-zone-image-newsletter-title {
  color: #787878;
}
.drop-zone-image-newsletter-upload-limit-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.drop-zone-image-newsletter-uploaded {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-image-newsletter-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  width: 100%;
  color: #a8a8a8;
  text-align: center;
  transform: translate(0, -50%);
}
.remove-image-newsletter {
  width: 200px;
}
.dialog-wrong-extension {
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
.chart-wrapper {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
@media (max-width: 1264px) {
  .chart-wrapper {
    justify-content: center;
  }
}
.statistic-title {
  font-size: 16px;
  white-space: normal;
  word-break: break-word;
}
@media (min-width: 600px) {
  .statistic-title {
    font-size: 16px;
  }
}
.card-add-specific-keyword {
  color: #0471A5;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 8px;
}
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}
.rotate-animation {
  animation: rotateFrom90 1s linear;
}
@keyframes rotateFrom90 {
  from {
    transform: rotate(90deg);
  }
  to {
    transform: rotate(-450deg);
  }
}
.loading-dots {
  color: var(--color-theme);
  font-size: 32px;
  font-weight: bold;
  display: inline-flex;
}
.loading-dots span {
  animation: blink 1.5s infinite;
  margin: 0 2px;
}
.loading-dots span:nth-child(1) { animation-delay: 0s; }
.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}
.response-text-describe-dashboard {
  background: #f4f4f4;
  color: #2e2e2e;
  display: block;
  overflow-x: auto;
  max-height: 100%;
  max-width: 100%;
  border-radius: 8px;
  line-height: 1.6;
  padding: 10px;
}
.response-text-describe-dashboard strong {
  display: block;
  margin-bottom: 4px;
}
.response-text-describe-dashboard ul {
  margin-top: 4px;
  padding-left: 20px;
}
.btn-close-dialog-search-context {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  margin-left: auto;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}
::v-deep .apexcharts-pie-area {
  opacity: 1;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
::v-deep .apexcharts-slices:hover .apexcharts-pie-area:not(:hover) {
  opacity: 0.3 !important;
  transition: opacity 0.3s ease;
}
::v-deep .apexcharts-slices .apexcharts-pie-area:hover {
  opacity: 1 !important;
  transition: opacity 0.3s ease;
  filter: brightness(1.15) drop-shadow(0 0 8px rgba(0,0,0,0.2));
}
::v-deep .apexcharts-datalabels,
::v-deep .apexcharts-datalabel,
::v-deep .apexcharts-datalabel-label,
::v-deep .apexcharts-datalabel-value {
  opacity: 1 !important;
  pointer-events: none;
}
.overflow-card {
  overflow-y: auto;
  overflow-x: hidden;
}
.content-list-card {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
}
.content-list-card:hover {
  border-radius: 8px;
  border: 0.6px solid #E4E4E4;
  background: #FFF;
  box-shadow: 3px 5px 7px 0px #E4E4E4 !important;
}
.v-avatar.color-avatar-total-collected-data {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar-most-crawled-keyword {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar-least-crawled-keyword {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar-berita-online {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar-x-tik-tok-threads {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatar-youtube {
  background-image:
  linear-gradient(to right top, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000) !important;
}
.v-avatar.color-avatar-instagram {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
.v-avatar.color-avatar-facebook {
  background-image: linear-gradient(to right top, #1877F2, #1877F2);
}
.v-pagination {
  z-index: 10 !important;
  position: relative;
}
.chart-bar-card-wrapper {
  margin: 0 auto;
  padding: 1rem;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}
::v-deep .apexcharts-toolbar,
::v-deep .apexcharts-menu {
  z-index: 1 !important;
}
.custom-tooltip {
  font-size: 12px;
  border-radius: 5px;
  padding: 5px;
}
.custom-tooltip span {
  display: block;
  font-size: 12px;
  margin-bottom: 3px;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
</style>
